<template>
  <v-container fluid v-if="tiene_empresa">
    <v-data-table :headers="headers" :items="items" :search="search" dense :loading="loading_facturas">
      <template v-slot:top>
        <v-toolbar flat>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="listarFacturas()" v-bind="attrs" v-on="on">
                fa-solid fa-rotate-right
              </v-icon>
            </template>
            <span>Actualizar</span>
          </v-tooltip>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-btn color="primary" @click="dialog_enviar_todo = true"
            v-if="$store.state.usuario.idUsuario == 108 || $store.state.usuario.rol == 'IT'">Enviar todo</v-btn>
          <v-spacer></v-spacer>
          <v-combobox :items="sugerencias_busqueda" :search-input.sync="search" label="Buscar" outlined dense
            hide-details clearable hide-no-data></v-combobox>
          <v-spacer></v-spacer>
          <v-btn v-if="VerCorteCaja" class="mx-3" color="green" dark @click="cortecaja()">Corte Caja</v-btn>
          <v-btn color="primary" @click="nuevaFactura()"> Nuevo </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:[`item.fecha`]="{ item }">
        <span> {{ formatoFecha(item.fecha) }}</span>
      </template>

      <template v-slot:[`item.observaciones`]="{ item }">
        <span>{{ (item.observaciones || "").toUpperCase() }}</span>
      </template>

      <template v-slot:[`item.total_pagar`]="{ item }">
        <span> $ {{ Number(item.total_pagar).toFixed(2) }}</span>
      </template>

      <template v-slot:[`item.nombre_cliente`]="{ item }">
        <span>
          {{
            (item.cod_doc_fiscal || "").toUpperCase().trim() === "CCF"
              ? item.nombre || item.cliente_nombre || item.nombre_cliente || ""
              : item.nombre_cliente || item.cliente_nombre || item.nombre || ""
          }}
        </span>
      </template>

      <template v-slot:[`item.estatus`]="{ item }">
        <v-tooltip left color="primary" v-if="
          item.sello_recepcion == '' && item.resolucion_invalidacion == null
        ">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" v-bind="attrs" v-on="on">fa-regular fa-floppy-disk</v-icon>
          </template>
          <span>GUARDADO</span>
        </v-tooltip>

        <v-tooltip left color="success" v-else-if="
          item.sello_recepcion != '' && item.resolucion_invalidacion == null
        ">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="success" v-bind="attrs" v-on="on">fa-regular fa-circle-check</v-icon>
          </template>
          <span>PROCESADO</span>
        </v-tooltip>

        <v-tooltip left color="error" v-else-if="
          item.resolucion_invalidacion != '' &&
          item.resolucion_invalidacion != null
        ">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="error" v-bind="attrs" v-on="on">fa-solid fa-ban</v-icon>
          </template>
          <span>ANULADO</span>
        </v-tooltip>

        <v-tooltip left color="error" v-else-if="item.estatus == 'ERROR'">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="error" v-bind="attrs" v-on="on">fa-solid fa-circle-exclamation</v-icon>
          </template>
          <span>ERROR</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.action_edit`]="{ item }">
        <v-icon @click="editarFactura(item)">
          fa-solid fa-pen-to-square
        </v-icon>
      </template>

      <template v-slot:[`item.action_send_dte`]="{ item }">
        <v-icon @click="puedeEnviarDTE && item.sello_recepcion == '' ? enviarDTE(item) : null"
          :color="puedeEnviarDTE && item.sello_recepcion == '' ? '' : 'grey'" :style="{
            cursor: puedeEnviarDTE && item.sello_recepcion == '' ? 'pointer' : 'not-allowed',
            opacity: puedeEnviarDTE && item.sello_recepcion == '' ? 1 : 0.5
          }">
          fa-regular fa-paper-plane
        </v-icon>
      </template>

      <template v-slot:[`item.action_view_dte`]="{ item }">
        <v-icon @click="vistaPreviaPdf(item)" v-if="item.sello_recepcion == ''">
          fa-regular fa-file-pdf
        </v-icon>
        <v-icon @click="vistaPreviaPdfSello(item)" v-else-if="item.sello_recepcion != ''">
          fa-regular fa-file-pdf
        </v-icon>
      </template>

      <template v-slot:[`item.action_view_ticket`]="{ item }">
        <v-icon @click="verTicket(item)"> fa-solid fa-receipt </v-icon>
      </template>

      <template v-slot:[`item.action_send_mail`]="{ item }">
        <v-icon @click="reenviarCorreo(item)" :disabled="item.sello_recepcion == ''">
          fa-regular fa-envelope
        </v-icon>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" persistent width="3000" scrollable>
      <v-card>
        <v-toolbar elevation="0" v-if="false">
          <v-row class="mx-8" no-gutters>
            <v-col cols="2" align-self="center" v-if="false">
              <v-text-field v-model="nom_usuario" label="Usuario" dense outlined hide-details readonly></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" align-self="center" v-if="false">
              <v-checkbox v-model="otros_factura" label="Otros" hide-details @change="handleOtrosChange"
                :disabled="extingido_cautelado"></v-checkbox>
            </v-col>
            <v-col cols="auto" align-self="center" v-if="false">
              <v-checkbox v-model="extingido_cautelado" label="Extinguido" hide-details
                :disabled="otros_factura"></v-checkbox>
            </v-col>
            <v-col cols="2" v-if="false">
              <v-text-field v-model="codigo_bien" label="Código del bien" outlined dense hide-details
                :disabled="otros_factura"></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
        <v-card-text>
          <!-- PRIMERA PARTE CORRELATIVOS-->
          <v-card class="mx-8 my-2">
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="12" md="6" class="pa-1">
                  <v-text-field v-model="numero_control" label="Numero de control" outlined dense hide-details
                    readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pa-1">
                  <v-text-field v-model="codigo_generacion" label="Codígo de generación" outlined dense hide-details
                    readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pa-1">
                  <v-text-field v-model="fecha_hora" label="Fecha y hora" type="datetime-local" outlined dense
                    hide-details readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="3" class="pa-1">
                  <v-text-field v-model="sello_recepcion" label="Sello de recepción" outlined dense hide-details
                    readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="3" class="pa-1">
                  <v-text-field v-model="fecha_recepcion" label="Fecha de recepción" type="datetime-local" outlined
                    dense hide-details readonly></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <!-- SEGUNDA PARTE SUCARSAL, TIPO DOC-->
          <v-card class="mx-8 mb-2">
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="12" md="6" class="pa-1">
                  <v-autocomplete v-model="sucursal" :items="items_sucursales" item-text="nombre"
                    item-value="id_sucursal" label="Sucursal" auto-select-first outlined dense hide-details
                    @input="listarTipoDocs(), listarPuntosVenta('manual')"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" class="pa-1">
                  <v-autocomplete v-model="punto_venta" :items="items_punto_venta" item-text="descripcion"
                    item-value="id_punto_venta" label="Punto de venta" outlined dense hide-details
                    @input="listarTipoDocs()"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" class="pa-1">
                  <v-autocomplete v-model="tipo_doc_fiscal" :items="items_tipo_doc_fiscales"
                    item-text="nombre_doc_fiscal" item-value="id_tipo_doc_fiscal" label="Tipo Documento" outlined dense
                    hide-details return-object @change="
                      listarTipoDocs();
                    llamarCalculo();
                    " @input="listarDocSeleccionado()" />
                </v-col>
                <v-col cols="12" md="4" align-self="center">
                  <v-btn block @click="listarCCF()" :disabled="tipo_doc_fiscal.cod_doc_fiscal != 'NCR' &&
                    tipo_doc_fiscal.cod_doc_fiscal != 'NDB'
                    ">
                    <v-icon left>fa-solid fa-file-invoice-dollar</v-icon>
                    BUSCAR CCF
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4" class="pa-1">
                  <v-autocomplete v-model="tipo_pago" :items="items_tipo_pago" label="Tipo Pago" outlined dense
                    hide-details></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" v-if="false">
                  <v-autocomplete v-model="tipo_operacion" :items="items_tipo_operacion" label="Tipo operación"
                    item-text="tipo_operacion" item-value="codigo" class="pa-1" outlined dense
                    hide-details></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" v-if="false">
                  <v-autocomplete v-model="tipo_ingreso" :items="items_tipo_ingreso" label="Tipo ingreso"
                    item-text="descripcion" item-value="codigo" class="pa-1" outlined dense
                    hide-details></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <!-- TERCERA PARTE CLIENTE-->
          <v-card class="mx-8 mb-2">
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="12" md="3" class="pa-1">
                  <v-autocomplete v-model="cliente" :items="items_clientes" item-text="nombre" item-value="codigo"
                    label="Cliente" outlined dense hide-details return-object @input="setCliente()">
                    <template v-slot:selection="data">
                      {{ data.item.codigo }}
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.codigo }} {{ data.item.nombre }}
                    </template>
                  </v-autocomplete>
                </v-col>
                <!-- Botón NUEVO  -->
                <v-col cols="auto" class="pa-1">
                  <v-btn color="success" @click="dialogNuevoCliente()">
                    <v-icon>fas fa-plus</v-icon>
                  </v-btn>
                </v-col>

                <!-- Botón EDITAR  -->
                <v-col cols="auto" class="pa-1">
                  <v-btn color="grey" @click="dialogEditarCliente()" :disabled="id_cliente == 0 || !id_cliente">
                    <v-icon color="white">fas fa-edit</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" md="3" class="pa-1">
                  <v-text-field v-model="registro" label="Registro" outlined dense hide-details readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="pa-1">
                  <v-text-field v-model="identifiador" label="Identificador" outlined dense hide-details
                    readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="pa-1">
                  <v-text-field v-model="num_documento" label="Documento" outlined dense hide-details
                    readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="7" class="pa-1">
                  <v-text-field v-if="
                    tipo_doc_fiscal &&
                    tipo_doc_fiscal.cod_doc_fiscal === 'CCF'
                  " v-model="nombre" label="Nombre" outlined dense hide-details readonly />
                  <v-text-field v-else v-model="nombre_cliente" label="Nombre Cliente" outlined dense hide-details />
                </v-col>
                <v-col cols="12" md="2" class="pa-1">
                  <v-text-field v-model="tipo" label="Tipo" outlined dense hide-details readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="pa-1">
                  <v-text-field v-model="telefono" label="Teléfono" outlined dense hide-details readonly></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <!-- TABLA SERVICIOS -->
          <v-card class="mx-8 mb-2">
            <v-card-text>
              <v-data-table :headers="headers_productos" :items="items_productos" dense item-key="id"
                :items-per-page="-1" :footer-props="{ 'items-per-page-options': [10, 25, 50, -1] }">
                <template v-slot:top>
                  <v-row justify="space-around" no-gutters>
                    <v-col cols="12" md="1" class="pa-1">
                      <v-text-field v-model="observaciones" label="Vendedor" outlined dense hide-details></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1" class="pa-1">
                      <v-text-field v-model="cantidad" label="Cantidad" outlined dense hide-details type="number"
                        :disabled="tipo_doc_fiscal == ''" @input="calculoCantidad"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1" class="pa-1" v-if="false">
                      <v-text-field v-model="producto" label="Servicio" outlined dense hide-details
                        :disabled="cantidad <= 0 || tipo_doc_fiscal == ''"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="auto" class="pa-1">
                      <v-btn outlined @click="dialog_servicios = true" :disabled="tipo_doc_fiscal == ''" block>
                        <v-icon>fa-solid fa-magnifying-glass</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="4" class="pa-1">
                      <v-combobox v-model="descripcion" :items="items_busqueda_servicios" item-text="nom_servicio"
                        item-value="nom_servicio" label="Descripción" outlined dense hide-details
                        :search-input.sync="buscarServicio" :return-object="false"
                        @change="onSeleccionServicio"></v-combobox>
                    </v-col>
                    <v-col cols="12" md="1" class="pa-1">
                      <v-text-field ref="valPrecio" v-model="precio" label="Precio con IVA" outlined dense hide-details
                        type="number" :min="0.01" @keydown="validarEntradas" @paste="validarEntradaCopyPaste"
                        :disabled="descripcion == ''" @input="limpiarCerosIniciales1"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1" class="pa-1">
                      <v-text-field ref="valDescuento" v-model="descuento_prod" label="%Desc" outlined dense
                        hide-details type="number" :min="0" @keydown="validarEntradas" @paste="validarEntradaCopyPaste"
                        :disabled="descripcion == ''" @change="calculoDescuento()"
                        @input="limpiarCerosIniciales2"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1" class="pa-1">
                      <v-text-field v-model="total" label="Total" outlined dense hide-details type="number"
                        disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" md="auto" class="pa-1">
                      <v-btn @click="agregarProducto()" :disabled="sello_recepcion != ''" block>
                        <v-icon color="green">fa-solid fa-square-check</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>

                <template v-slot:[`item.precio`]="{ item }">
                  <span> $ {{ Number(item.precio).toFixed(4) }}</span>
                </template>

                <template v-slot:[`item.precio_con_iva`]="{ item }">
                  <span>$ {{ Number(item.precio_con_iva).toFixed(4) }}</span>
                </template>

                <template v-slot:[`item.descuento`]="{ item }">
                  <span> % {{ Number(item.descuento).toFixed(2) }}</span>
                </template>

                <template v-slot:[`item.total`]="{ item }">
                  <span> $ {{ Number(item.total).toFixed(2) }}</span>
                </template>

                <template v-slot:[`item.total_con_iva`]="{ item }">
                  <span> $ {{ Number(item.total_con_iva).toFixed(2) }}</span>
                </template>

                <template v-slot:[`item.action_edit`]="{ item }">
                  <v-icon @click="editarProducto(item)" :disabled="sello_recepcion != ''">
                    fa-solid fa-pen-to-square
                  </v-icon>
                </template>

                <template v-slot:[`item.action_delete`]="{ item }">
                  <v-icon class="mr-2" @click="eliminarDetalleFactura(item)" :disabled="sello_recepcion != ''">
                    fa-solid fa-trash-can
                  </v-icon>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <!-- ULTIMA PARTE CALCULOS-->
          <v-row no-gutters justify="center" align="center" class="mx-8">
            <v-card width="150" class="ma-1" v-if="false">
              <v-col cols="12">
                <v-text-field v-model="otros_cargos" label="Otros Cargos" prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="anticipo" label="Anticipo" prepend-inner-icon="fa-solid fa-dollar-sign" outlined
                  dense hide-details readonly></v-text-field>
              </v-col>
            </v-card>

            <v-card width="150" class="ma-1">
              <v-col cols="12">
                <v-text-field v-model="sub_total" label="Sub-total" prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined dense hide-details readonly></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="descuento" label="Descuento" prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined dense hide-details :readonly="flag_descuento"></v-text-field>
              </v-col>
            </v-card>

            <v-card width="150" class="ma-1">
              <v-col cols="12">
                <v-text-field v-model="gravadas" label="Gravadas" prepend-inner-icon="fa-solid fa-dollar-sign" outlined
                  dense hide-details readonly></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="iva" label="IVA" prepend-inner-icon="fa-solid fa-dollar-sign" outlined dense
                  hide-details readonly></v-text-field>
              </v-col>
            </v-card>

            <v-card width="150" class="ma-1">
              <v-col cols="12">
                <v-text-field v-model="exentas" label="Exentas" prepend-inner-icon="fa-solid fa-dollar-sign" outlined
                  dense hide-details readonly></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="no_sujetas" label="No sujetas" prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined dense hide-details readonly></v-text-field>
              </v-col>
            </v-card>

            <v-card width="150" class="ma-1">
              <v-col cols="12">
                <v-text-field v-model="calculoRetencion" label="Retención" prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined dense hide-details readonly></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="percepcion" label="Percepción" prepend-inner-icon="fa-solid fa-dollar-sign"
                  outlined dense hide-details readonly></v-text-field>
              </v-col>
            </v-card>

            <v-card width="150" class="ma-1">
              <v-col cols="12">
                <v-text-field v-model="calculoTotalOperacion" label="Total operación"
                  prepend-inner-icon="fa-solid fa-dollar-sign" outlined dense hide-details readonly></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="calculoTotalPagar" label="Total a pagar"
                  prepend-inner-icon="fa-solid fa-dollar-sign" outlined dense hide-details readonly></v-text-field>
              </v-col>
            </v-card>
          </v-row>
        </v-card-text>

        <v-card-actions style="background-color: white">
          <v-btn color="primary" @click="crearfactura()" v-if="flag_new_edit == 1"
            :loading="loading_guardar">Guardar</v-btn>
          <v-btn color="primary" @click="actualizarfactura()" v-if="flag_new_edit == 2"
            :disabled="sello_recepcion != ''">Actualizar</v-btn>
          <v-btn color="red" @click="confirmarAnularDocumento()" v-if="
            flag_new_edit == 2 &&
            ($store.state.usuario.rol == 'Administrador' ||
              $store.state.usuario.rol == 'IT') &&
            sello_recepcion != '' &&
            resolucion_invalidacion == null
          " :disabled="sello_recepcion == ''">Anular</v-btn>
          <v-btn color="red" @click="eliminarFactura()" v-if="
            flag_new_edit === 2 &&
            ($store.state.usuario.rol === 'Administrador' ||
              $store.state.usuario.rol === 'IT') &&
            sello_recepcion === ''
          " :loading="loading_eliminar_factura" dark>Eliminar</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialog">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_anexo" persistent max-width="500px">
      <v-card>
        <v-card-title class="text-h6"> Corte de Caja Diaria </v-card-title>

        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="12" class="pa-2">
              <v-text-field v-model="fecha_anexo" label="Fecha" type="date" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="justify-center pt-4">
          <v-btn color="cyan" large @click="descargarArchivo('pdf')" class="mx-4">
            PDF
          </v-btn>
          <v-btn color="green" large @click="TicketCorteCaja()" class="mx-4">
            TICKET
          </v-btn>
          <v-btn color="red" large @click="cerrarDialogAnexo()" class="mx-2">
            CANCELAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_eliminar_factura" width="500">
      <v-card>
        <v-card-title>¿Esta seguro de eliminar la factura <br />
          {{ numero_control }}?</v-card-title>
        <v-card-actions>
          <v-btn color="red" dark @click="confirmarEliminarFactura()">Eliminar</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_eliminar_factura = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_clientes">
      <v-data-table :headers="headers_clientes" :items="items_clientes" @dblclick:row="setCliente">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Clientes</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <div style="color: black">[Hacer doble click para seleccionar]</div>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-dialog>

    <v-dialog v-model="dialog_servicios">
      <v-data-table :headers="headers_servicios" :items="items_servicios" @dblclick:row="setServicio">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Servicios</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <div style="color: black">[Hacer doble click para seleccionar]</div>
          </v-toolbar>
        </template>
        <template v-slot:[`item.con_iva`]="{ item }">
          <v-simple-checkbox v-model="item.con_iva" disabled></v-simple-checkbox>
        </template>
      </v-data-table>
    </v-dialog>

    <v-dialog v-model="dialog_eliminar_servicio" width="500">
      <v-card>
        <v-card-title>¿Esta seguro de eliminar este servicio?</v-card-title>
        <v-card-actions>
          <v-btn color="red" dark @click="confirmarEliminarDetalleFactura()">Eliminar</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_eliminar_servicio = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_tabla_CCF" width="1500" scrollable>
      <v-card>
        <v-card-text class="pa-0">
          <v-data-table v-model="items_tipo_doc_ncr_ndb" :headers="headers_ccf" :items="items_ccf" :search="search_ccf"
            :item-class="colorTablaCCF" :show-select="tipo_doc_fiscal.cod_doc_fiscal == 'NDB'" item-key="id_factura"
            single-select>
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Facturas</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field v-model="search_ccf" label="Buscar" outlined dense hide-details></v-text-field>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>

            <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
              <v-simple-checkbox :value="isSelected" :disabled="fechaLimiteDebitoCredito(item)"
                @input="select($event)"></v-simple-checkbox>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-button @click="testCheck(item)"> Edit </v-button>
            </template>

            <template v-slot:[`item.action_add_servicio`]="{ item }">
              <v-btn v-if="tipo_doc_fiscal.cod_doc_fiscal == 'NCR'" icon @click="listarServiciosDocNCR(item)"
                elevation="3" color="black">
                <v-icon>fa-solid fa-check</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.fecha`]="{ item }">
              <span>{{ formatoFecha(item.fecha) }}</span>
            </template>

            <template v-slot:[`item.gravadas`]="{ item }">
              <span> $ {{ item.gravadas.toFixed(4) }}</span>
            </template>

            <template v-slot:[`item.iva`]="{ item }">
              <span> $ {{ item.iva.toFixed(4) }}</span>
            </template>

            <template v-slot:[`item.total_pagar`]="{ item }">
              <span> $ {{ item.total_pagar.toFixed(4) }}</span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_tabla_CCF = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_tabla_detalles_fac" width="1500" persistent>
      <v-card>
        <v-data-table v-model="items_productos" :headers="headers_detalles_fac" :items="items_detalles_fac"
          :search="search_detalles_fac" item-key="id_detalle_factura" show-select :item-class="colorTablaDetalles">
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Detalles</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field v-model="search_detalles_fac" label="Buscar" outlined dense hide-details></v-text-field>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>

          <template v-slot:[`item.precio`]="{ item }">
            <span> $ {{ item.precio.toFixed(4) }}</span>
          </template>

          <template v-slot:[`item.descuento`]="{ item }">
            <span> % {{ item.descuento.toFixed(4) }}</span>
          </template>

          <template v-slot:[`item.total`]="{ item }">
            <span> $ {{ item.total.toFixed(4) }}</span>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-btn color="primary" @click="agregarServiciosDocNCR()">Aplicar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_confirmar_anular" width="500">
      <v-card>
        <v-card-title>¿Esta seguro de anular el documento?</v-card-title>
        <v-card-actions>
          <v-btn color="red" @click="anularFactura()">Confirmar</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="dialog_confirmar_anular = !dialog_confirmar_anular">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_preview_report" fullscreen persistent>
      <v-toolbar flat dense>
        <v-toolbar-title> DOCUMENTO </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="dialog_preview_report = !dialog_preview_report">far fa-times-circle</v-icon>
      </v-toolbar>
      <iframe :src="base64_doc" id="myPDF" frameborder="0" />
    </v-dialog>

    <v-dialog v-model="dialog_enviar_todo" width="500" persistent>
      <v-card>
        <v-toolbar flat class="pa-1 mb-3 font-weight-bold">
          Esta opción es para poder enviar todas las facturas pendientes de una
          fecha
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="fecha_enviar_todo" label="Fecha" outlined dense hide-details type="date"
                :max="fecha_limite"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" :loading="loading_guardar" @click="enviarTodo()">Enviar todo</v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading="loading_guardar" text @click="dialog_enviar_todo = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ClientesCrearEditar :estado_dialog.sync="dialog_crear_editar_cliente"
      :estado_nuevo_editar_dialog.sync="estado_crear_editar_cliente"
      :errorDocumentoIdentificador="errorDocumentoIdentificador" />

    <v-snackbar v-model="snackbar" timeout="-1" color="blue" multi-line elevation="24" outlined top right>
      <v-icon :style="'color:' + this.snackbar_icon_color" large>{{
        icon_snackbar
      }}</v-icon>
      {{ snackbar_text }} <br />
      {{ snackbar_obs }}

      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="snackbar = false">
          <v-icon>fa-regular fa-circle-xmark</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import settings from "@/settings/settings";
import axios from "axios";
import Papa from "papaparse";
import { PDFDocument, StandardFonts, rgb, PageSizes } from "pdf-lib";
import printJS from "print-js";
import ClientesCrearEditar from "@/views/Clientes_Crear_Editar.vue";
import store from "@/store";
const signalR = require("@microsoft/signalr");

export default {
  data: () => ({
    fecha_enviar_todo: "",
    fecha_limite: new Date().toISOString().split("T")[0],
    dialog_enviar_todo: false,
    items_csv: [],
    flag_csv: "no",
    data_file_input: [],
    result_data_facturas: [],
    loading_guardar: false,
    snackbar: false,
    snackbar_text: "",
    snackbar_obs: "",
    snackbar_icon_color: "primary",
    icon_snackbar: "fa-solid fa-circle-info",
    empresa: "OTROS",
    search: "",
    dialog: false,
    dialog_clientes: false,
    headers: [
      { text: "Número Control", value: "numero_control" },
      { text: "Fecha", value: "fecha", width: "150", sortable: false },
      {
        text: "Vendedor",
        value: "observaciones",
        align: "center",
        sortable: false,
      },
      {
        text: "Tipo Doc.",
        value: "cod_doc_fiscal",
        width: "90",
        align: "center",
        sortable: false,
      },
      { text: "Cliente", value: "nombre_cliente" },
      {
        text: "Total",
        value: "total_pagar",
        align: "center",
        width: "100",
        sortable: false,
      },
      {
        text: "Estatus",
        value: "estatus",
        align: "center",
        width: "80",
        sortable: false,
      },
      {
        text: "Enviar DTE",
        value: "action_send_dte",
        align: "center",
        align: "center",
        width: "80",
        sortable: false,
      },
      {
        text: "Ver DTE",
        value: "action_view_dte",
        align: "center",
        align: "center",
        width: "80",
        sortable: false,
      },
      {
        text: "Ver ticket",
        value: "action_view_ticket",
        align: "center",
        align: "center",
        width: "80",
        sortable: false,
      },
      { text: "Reenviar correo", value: "action_send_mail", align: "center", width: "80", sortable: false },
      {
        text: "Editar",
        value: "action_edit",
        align: "center",
        align: "center",
        width: "80",
        sortable: false,
      },
    ],
    items: [],
    id_factura: 0,
    id_empresa: 0,
    id_tipo_doc_fiscal: 0,
    dialog_eliminar_servicio: false,
    extingido_cautelado: false,
    codigo_bien: "",
    //Nuevo
    otros_factura: false,
    //CLIENTES
    id_cliente: 0,
    headers_clientes: [
      { text: "Cliente", value: "codigo", sorteable: false },
      { text: "Nombre", value: "nombre", sorteable: false },
      { text: "Registro", value: "registro", sorteable: false },
      {
        text: "Identificador",
        value: "identificador_nombre",
        sorteable: false,
      },
      { text: "Teléfono", value: "telefono", sorteable: false },
      { text: "Tipo", value: "tipo_persona", sorteable: false },
    ],
    items_clientes: [],
    cliente_exento: false,
    cliente_retencion: false,
    cliente_percepcion: false,
    cliente_tamaño: "",
    cliente_extranjero: false,
    //DTE-00-00000000-000000000000000
    numero_control: "DTE-00-00000000-000000000000000",
    codigo_generacion: "",
    fecha_hora: "",
    sello_recepcion: "",
    fecha_recepcion: "",
    cliente: "",
    nombre: "",
    registro: "",
    nombre_cliente: "CLIENTE X",
    identifiador: "",
    telefono: "",
    tipo: "",
    num_documento: "",
    consignado_a: "",
    tipo_doc_fiscal: "",
    items_tipo_doc_fiscales: [],
    tipo_pago: "CONTADO",
    items_tipo_pago: ["CONTADO", "CREDITO"],
    contador_tipo_doc_fiscal: 0,
    sello_invalidacion: "",
    nombre_creacion_fac: "",
    dialog_eliminar_factura: false,
    loading_eliminar_factura: false,
    id_usuario: "",
    nom_usuario: "",
    tipo_operacion: "",
    items_tipo_operacion: [],
    tipo_ingreso: "",
    items_tipo_ingreso: [],
    resolucion_invalidacion: "",
    //SUCURSAL
    sucursal: "",
    items_sucursales: [],
    punto_venta: "",
    items_punto_venta: [],
    cod_sucursal_mh: "",
    cod_punto_venta_mh: "",
    //IDENTIFICADORES
    items_identificador: [],
    //TABLA PRODUCTO
    headers_productos: [
      { text: "Cantidad", value: "cantidad" },
      { text: "Producto", value: "cod_servicio" },
      { text: "Descripción", value: "descripcion" },
      { text: "Precio sin IVA", value: "precio" },
      { text: "Precio con IVA", value: "precio_con_iva" },
      { text: "Descuento", value: "descuento" },
      { text: "Total", value: "total" },
      { text: "Total con IVA", value: "total_con_iva" },
      { text: "Editar", value: "action_edit" },
      { text: "Eliminar", value: "action_delete" },
    ],
    items_productos: [],
    cantidad: 1,
    producto: "",
    descripcion: "",
    precio: 0,
    precio_con_iva: 0,
    descuento_prod: 0,
    monto_descuento: 0,
    total: 0,
    exento_prod: false,
    no_sujeto_prod: false,
    id_detalle_factura: 0,
    cont_prod: 0,
    id: 0,
    item_servicio_eliminar: "",
    con_iva_prod: null,
    //CALCULO DE VALORES
    otros_cargos: 0.0,
    anticipo: 0.0,
    sub_total: 0.0,
    descuento: 0.0,
    gravadas: 0.0,
    iva: 0.0,
    exentas: 0.0,
    no_sujetas: 0.0,
    retencion: 0.0,
    percepcion: 0.0,
    total_operacion: 0.0,
    total_pagar: 0.0,
    flag_descuento: false,
    flag_new_edit: 1,
    //TABLA CCF
    dialog_tabla_CCF: false,
    search_ccf: "",
    headers_ccf: [
      { text: "Servicios", value: "action_add_servicio" },
      { text: "Numero de control", value: "numero_control" },
      { text: "Fecha", value: "fecha" },
      { text: "Tipo documento", value: "tipo_documento_nombre" },
      { text: "Tipo pago", value: "tipo_pago" },
      { text: "Código cliente", value: "cliente_codigo" },
      { text: "Cliente", value: "cliente_nombre" },
      { text: "Gravadas", value: "gravadas" },
      { text: "IVA", value: "iva" },
      { text: "Total", value: "total_pagar" },
    ],
    items_ccf: [],
    //TABLA DETALLES FACTURA
    dialog_tabla_detalles_fac: false,
    search_detalles_fac: "",
    headers_detalles_fac: [
      { text: "Cantidad", value: "cantidad" },
      { text: "Descripción", value: "descripcion" },
      { text: "Precio", value: "precio" },
      { text: "%Descuento", value: "descuento" },
      { text: "Total", value: "total" },
    ],
    items_detalles_fac: [],
    //DOCUMENTO NCR
    items_tipo_doc_ncr_ndb: [],
    lista_nrc_ndb_guardados: [],
    //SERVICIOS
    dialog_servicios: false,
    headers_servicios: [
      { text: "Producto", value: "cod_servicio" },
      { text: "Descripción", value: "nom_servicio" },
      {
        text: "Con IVA",
        value: "con_iva",
        sortable: false,
        align: "center",
      },
      { text: "Precio", value: "precio" },
    ],
    items_servicios: [],
    flag_servicio: true,
    dialog_confirmar_anular: false,
    dialog_preview_report: false,
    base64_doc: "",
    loading_facturas: true,
    //Anexo Ventas
    dialog_anexo: false,
    anulado: "",
    renta: "",
    anio: "2025",
    mes: "",
    sucursal: "",
    items_mes: [],
    buscarServicio: null,
    items_busqueda_servicios: [],
    observaciones: "",
    //Crear Editar Cliente
    dialog_crear_editar_cliente: false,
    estado_crear_editar_cliente: "",
    errorDocumentoIdentificador: "",
    connection: "",
    bootstrapped: false,
    recalcular_automatico: true,
    //Corte Caja
    fecha_anexo: "",
    dialog_anexo: false,
    enviarDisabled: false,
    enviarDisabledMsg: "",
    corteTimerId: null,
    horaTick: Date.now(),
    tickId: null,
  }),
  components: {
    ClientesCrearEditar,
  },
  mounted() {
    this.connection.on("Receive", (user, data) => {
      const insertdata = { name: user, message: data };

      //console.log("escuchando...", insertdata);
      this.listarFacturas();
    });
  },
  created() {
    if (this.flag_csv == "si") {
      this.obtenerCorrelativoTipoDocCSV(12);
    }
    this.listarTipoOperacion();
    this.listarTipoIngresos();
    this.listarMes();

    this.connection = new signalR.HubConnectionBuilder()
      .withAutomaticReconnect()
      .withUrl(process.env.VUE_APP_URL_API + "/hubResponse", {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .build();

    this.connection
      .start()
      .then(() => {
        console.log("Conexión establecida");
      })
      .catch((error) => {
        //console.log(error);
      });

    this.tickId = setInterval(() => {
      this.horaTick = Date.now();
    }, 30000);
  },
  beforeDestroy() {
    if (this.tickId) clearInterval(this.tickId);
  },
  computed: {
    sugerencias_busqueda() {
      const set = new Set();
      for (const it of this.items) {
        if (it.nombre_cliente) set.add(String(it.nombre_cliente).trim());
        if (it.numero_control) set.add(String(it.numero_control).trim());
        if (it.observaciones) set.add(String(it.observaciones).trim().toUpperCase());
      }
      return Array.from(set).filter(Boolean);
    },

    tiene_empresa() {
      if (this.$store.state.emp) {
        this.listarFacturas();
        this.listarUsuarioSucursal();
        this.listarSucursales();
        this.listarClientes();
        this.listarServicios();
        this.bootstrapped = true;
        return true;
      } else {
        return false;
      }
    },
    calculoSubTotal() {
      return this.sub_total;
    },

    calculoRetencion() {
      if (this.tipo_doc_fiscal.cod_doc_fiscal == "FAC") {
        if (this.cliente_retencion) {
          if (this.gravadas >= 100) {
            this.retencion = ((this.gravadas / 1.13) * 0.01).toFixed(4);
          }
        }
      } else {
        if (this.cliente_retencion) {
          if (this.gravadas >= 100) {
            this.retencion = (Number(this.gravadas) * Number(0.01)).toFixed(4);
          }
        }
      }
      return this.retencion;
    },
    calculoCantidad() {
      this.total = (Number(this.cantidad) * Number(this.precio)).toFixed(4);
    },
    calculoTotalOperacion() {
      const cod = (
        (this.tipo_doc_fiscal && this.tipo_doc_fiscal.cod_doc_fiscal) ||
        ""
      ).toUpperCase();

      const grav = Number(this.gravadas || 0);
      const iva = Number(this.iva || 0);
      const exentas = Number(this.exentas || 0);
      const noSujetas = Number(this.no_sujetas || 0);
      const retencion = Number(this.retencion || 0);
      const percepcion = Number(this.percepcion || 0);

      if (cod === "NCR") {
        this.total_operacion = (grav + iva - retencion).toFixed(2);
      } else if (cod === "CCF") {
        this.total_operacion = (grav + iva + exentas + noSujetas).toFixed(2);
      } else {
        this.total_operacion = (
          grav +
          exentas +
          noSujetas -
          retencion +
          percepcion
        ).toFixed(2);
      }

      return this.total_operacion;
    },

    calculoTotalPagar() {
      const cod = (
        (this.tipo_doc_fiscal && this.tipo_doc_fiscal.cod_doc_fiscal) ||
        ""
      ).toUpperCase();

      const grav = Number(this.gravadas || 0);
      const iva = Number(this.iva || 0);
      const exentas = Number(this.exentas || 0);
      const noSujetas = Number(this.no_sujetas || 0);
      const retencion = Number(this.retencion || 0);
      const percepcion = Number(this.percepcion || 0);
      const otrosCargos = Number(this.otros_cargos || 0);
      const anticipo = Number(this.anticipo || 0);

      if (cod === "CCF") {
        this.total_pagar = (
          grav +
          iva +
          exentas +
          noSujetas -
          retencion +
          percepcion +
          otrosCargos -
          anticipo
        ).toFixed(2);
      } else {
        this.total_pagar = (
          grav +
          exentas +
          noSujetas -
          retencion +
          percepcion +
          otrosCargos -
          anticipo
        ).toFixed(2);
      }

      return this.total_pagar;
    },

    puedeEnviarDTE() {
      this.horaTick;

      const ahora = new Date();
      const hora = ahora.getHours();

      return hora < 16;
    },

    VerCorteCaja() {
      const rol = ((this.$store.state.usuario?.rol || "") + "")
        .trim()
        .toUpperCase();
      return rol === "ADMINISTRADOR" || rol === "IT";
    },
  },
  watch: {
    buscarServicio(val) {
      if (!val || this.id_detalle_factura !== 0) {
        this.items_busqueda_servicios = [];
        return;
      }

      if (val.length < 3) {
        this.items_busqueda_servicios = [];
        return;
      }

      axios
        .get(
          "api/Servicios/ObtenerServicioPorDescripcion/" +
          encodeURIComponent(val) +
          "/" +
          this.$store.state.emp.id_empresa
        )
        .then((response) => {
          this.items_busqueda_servicios = response.data || [];
        });
    },

    dialog_crear_editar_cliente(val, oldVal) {
      if (oldVal === true && val === false) {
        const codigoSel =
          this.cliente && this.cliente.codigo ? this.cliente.codigo : null;
        this.listarClientes();
        this.$nextTick(() => {
          if (codigoSel) {
            const found = this.items_clientes.find(
              (c) => c.codigo === codigoSel
            );
            if (found) this.cliente = found;
          }
        });
      }
    },

    tipo_doc_fiscal: {
      deep: true,
      handler(nuevo, viejo) {
        if (
          !nuevo ||
          !this.items_productos ||
          this.items_productos.length === 0
        ) {
          return;
        }
        this.llamarCalculo();
      },
    },
  },
  methods: {
    async enviarTodo() {
      if (this.fecha_enviar_todo == "") {
        this.snackbar_text = "Debe de seleccionar una fecha";
        this.snackbar = true;
        return;
      }
      this.loading_guardar = true;
      for (var i = 0; i < this.items.length; i++) {
        if (
          this.items[i].sello_recepcion == "" &&
          settings.metodos.formatoFecha(this.fecha_enviar_todo) ==
          settings.metodos.formatoFecha(this.items[i].fecha)
        ) {
          //console.log(this.items[i]);
          await axios
            .post("api/ServicioRecepciones/FirmarDocumento2", {
              cod_emp: this.$store.state.emp.id_empresa,
              tipoDte: this.items[i].cod_doc_fiscal,
              idFactura: this.items[i].id_factura,
              ambiente: await this.obtenerAmbiente(),
            })
            .then((response) => {
              if (response.data.estado == "RECHAZADO") {
                this.snackbar_text =
                  this.snackbar_text +
                  " " +
                  this.items[i].numero_control +
                  ": " +
                  response.data.estado +
                  " " +
                  response.data.descripcionMsg +
                  "\n\n";
              }
              this.listarFacturas();
            });
        }
      }
      this.dialog_enviar_todo = false;
      this.loading_guardar = false;
      this.alerta("info", this.snackbar_text);
    },
    validarEntradas(e) {
      var tecla = e.key;
      if (tecla == "-" || tecla == "+" || tecla == "e") {
        e.preventDefault();
      }
    },
    validarEntradaCopyPaste(e) {
      var tecla = (e.clipboardData || window.clipboardData).getData("text");
      if (tecla == "-" || tecla == "+" || tecla == "e") {
        e.preventDefault();
      }
    },
    limpiarCerosIniciales1() {
      this.$nextTick(() => {
        const input = this.$refs.valPrecio?.$el.querySelector("input");
        if (input) {
          const valor = input.value;
          const limpio = valor.replace(/^0+(?=\d)/, "");
          if (valor !== limpio) {
            input.value = limpio;
            this.precio = limpio;
          }
        }
      });
    },
    limpiarCerosIniciales2() {
      this.$nextTick(() => {
        const input = this.$refs.valDescuento?.$el.querySelector("input");
        if (input) {
          const valor = input.value;
          const limpio = valor.replace(/^0+(?=\d)/, "");
          if (valor !== limpio) {
            input.value = limpio;
            this.descuento_prod = limpio;
          }
        }
      });
    },
    escucharServer() {
      axios.get("api/Usuarios/ListenServer");
    },
    async verTicket(item) {
      const items_productos =
        (await axios.get("api/Detallesfacturas/Listar/" + item.id_factura))
          .data || [];

      const pdfDoc = await PDFDocument.create();
      const timesRomanFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

      const fontSize = 50;
      const fontSizeTotales = fontSize + 15;
      const anchoPagina = 1100;
      const anchoTexto = anchoPagina - 20;

      // Parte un texto en varias líneas según el ancho disponible
      const partirTexto = (texto, maxAncho, size = fontSize) => {
        const limpio = String(texto || "").replace(/\s+/g, " ").trim();
        const palabras = limpio.split(" ");
        const lineas = [];
        let actual = "";
        for (const p of palabras) {
          const prueba = actual ? actual + " " + p : p;
          if (timesRomanFont.widthOfTextAtSize(prueba, size) > maxAncho && actual) {
            lineas.push(actual);
            actual = p;
          } else {
            actual = prueba;
          }
        }
        if (actual) lineas.push(actual);
        return lineas.length > 0 ? lineas : [""];
      };


      const descripciones = items_productos.map((it) =>
        partirTexto(it.descripcion, anchoTexto)
      );
      const totalLineas = descripciones.reduce((acc, d) => acc + d.length + 1, 0);
      const altoPagina = Math.max(4276, (35 + totalLineas) * fontSize + 150);

      const page = pdfDoc.addPage([anchoPagina, altoPagina]);
      const { width, height } = page.getSize();
      let cont = 25;

      const dibujar = (texto, x, y, size = fontSize) => {
        page.drawText(texto, {
          x: x,
          y: y,
          size: size,
          font: timesRomanFont,
          color: rgb(0, 0, 0),
        });
      };

      const dibujarCentrado = (texto, y, size = fontSize) => {
        const ancho = timesRomanFont.widthOfTextAtSize(texto, size);
        dibujar(texto, (width - ancho) / 2, y, size);
      };

   
      const margenDerecho = 40;
      const dibujarFila = (etiqueta, monto, y, size = fontSize) => {
        dibujar(etiqueta, 20, y, size);
        const anchoMonto = timesRomanFont.widthOfTextAtSize(monto, size);
        dibujar(monto, width - anchoMonto - margenDerecho, y, size);
      };

      // ===== ENCABEZADO =====
      dibujarCentrado("LIBRERIA SOLO", height - 4 * fontSize);
      dibujarCentrado("JOSE MARIO MEJIA ALVARENGA", height - 5 * fontSize);
      dibujarCentrado("EXPEDIDO EN:", height - 7 * fontSize);
      dibujarCentrado("SAN SALVADOR", height - 8 * fontSize);
      dibujarCentrado("REGISTRO: 154051-0", height - 10 * fontSize);
      dibujarCentrado("NIT: 0407-240749-001-8", height - 11 * fontSize);

      page.drawText("Código generación:" + item.codigo_generacion, {
        x: 1,
        y: height - 13 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
        lineHeight: 40,
        maxWidth: 1,
        wordBreaks: [":"],
      });
      page.drawText("Resolución:" + item.sello_recepcion, {
        x: 1,
        y: height - 16 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
        lineHeight: 40,
        maxWidth: 1,
        wordBreaks: [":"],
      });
      page.drawText("TICKET:" + item.numero_control, {
        x: 1,
        y: height - 19 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
        lineHeight: 40,
        maxWidth: 1,
        wordBreaks: [":"],
      });
      dibujar("FECHA: " + this.formatoFecha(item.fecha), 1, height - 22 * fontSize);
      dibujar(
        "----------------------------------------------------------------------------------",
        1,
        height - 23 * fontSize
      );
      dibujar("DESCRIPCION\t\t\t\t\t\tTOTAL", 1, height - 24 * fontSize);

      // ===== PRODUCTOS =====
      for (let i = 0; i < items_productos.length; i++) {
        const prod = items_productos[i];

        // Descripción en una o varias líneas
        for (const linea of descripciones[i]) {
          cont = cont + 1;
          dibujar(linea, 1, height - cont * fontSize);
        }

        cont = cont + 1;
        dibujarFila(
          prod.cantidad + "  * " + Number(prod.precio || 0).toFixed(2),
          "$" + Number(prod.total || 0).toFixed(2),
          height - cont * fontSize
        );
      }

      // ===== TOTALES =====
      dibujar(
        "----------------------------------------------------------------------------------",
        1,
        height - (cont + 1) * fontSize
      );
      dibujarFila(
        "SUBTOTAL",
        "$" + Number(item.total_operacion).toFixed(2),
        height - (cont + 2) * fontSize - 15,
        fontSizeTotales
      );
      dibujarFila(
        "DESCUENTO",
        "-$" + Number(item.descuento).toFixed(2),
        height - (cont + 3) * fontSize - 40,
        fontSizeTotales
      );
      dibujarFila(
        "TOTAL",
        "$" + Number(item.total_pagar).toFixed(2),
        height - (cont + 4) * fontSize - 65,
        fontSizeTotales
      );
      dibujarCentrado(
        "GRACIAS POR SU COMPRA VUELVA PRONTO",
        height - (cont + 8) * fontSize - 65,
        fontSize - 3
      );

      const b64encoded = await pdfDoc.saveAsBase64();

      printJS({
        printable: b64encoded,
        type: "pdf",
        base64: true,
      });
    },
    async TicketCorteCaja() {
      if (!this.fecha_anexo) {
        this.snackbar_text = "Seleccione una fecha";
        this.snackbar = true;
        return;
      }

      const facturas = (
        await axios.get("api/Facturas/Listar/" + this.$store.state.emp.id_empresa)
      ).data || [];

      const facturasDia = this.filtrarFacturasPorFecha(facturas, this.fecha_anexo);

      if (facturasDia.length === 0) {
        this.snackbar_text = "No hay documentos para la fecha seleccionada";
        this.snackbar = true;
        return;
      }

      const { grupos, totales } = this.resumenPorTipoDoc(facturasDia);

      const pdfDoc = await PDFDocument.create();
      const timesRomanFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

      const page = pdfDoc.addPage([1100, 3276]);
      const { height } = page.getSize();
      let cont = 25;
      const fontSize = 50;

      page.drawText("CORTE DE CAJA", {
        x: 350,
        y: height - 4 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
      });

      page.drawText("FECHA: " + this.formatoFecha(this.fecha_anexo), {
        x: 1,
        y: height - 6 * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
      });

      page.drawText(
        "----------------------------------------------------------------------------------",
        { x: 1, y: height - 7 * fontSize, size: fontSize, font: timesRomanFont, color: rgb(0, 0, 0) }
      );

      
      cont = 8;
      page.drawText("RESUMEN POR TIPO DE DOCUMENTO", {
        x: 1,
        y: height - cont * fontSize,
        size: fontSize,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
      });

      cont += 1;
      page.drawText("TIPO   CANT   TOTAL", {
        x: 1,
        y: height - cont * fontSize,
        size: fontSize - 5,
        font: timesRomanFont,
        color: rgb(0, 0, 0),
      });

      const tiposOrden = Object.keys(grupos).sort();
      for (const tipo of tiposOrden) {
        const g = grupos[tipo];

        cont += 1;
        const linea =
          `${tipo.padEnd(6)} ` +
          `${String(g.cantidad).padEnd(5)} ` +
          `${g.total_pagar.toFixed(2).padStart(10)}`;

        page.drawText(linea, {
          x: 1,
          y: height - cont * fontSize,
          size: fontSize - 8,
          font: timesRomanFont,
          color: rgb(0, 0, 0),
        });
      }

      cont += 1;
      page.drawText(
        "----------------------------------------------------------------------------------",
        { x: 1, y: height - cont * fontSize, size: fontSize, font: timesRomanFont, color: rgb(0, 0, 0) }
      );

      // ===== TOTAL GENERAL =====
      cont += 1;
      page.drawText(
        `TOTAL GENERAL (DOCS: ${totales.cantidad}):  $${totales.total_pagar.toFixed(2)}`,
        {
          x: 1,
          y: height - cont * fontSize,
          size: fontSize,
          font: timesRomanFont,
          color: rgb(0, 0, 0),
        }
      );

      const pdfBytes = await pdfDoc.save();
      const u8 = new Uint8Array(pdfBytes);
      const b64encoded = btoa(String.fromCharCode.apply(null, u8));

      printJS({
        printable: b64encoded,
        type: "pdf",
        base64: true,
      });
    },
    async obtenerAmbiente() {
      return (
        await axios.get(
          "api/DetallesEmpresas/ObtenerAmbiente/" +
          this.$store.state.emp.id_empresa
        )
      ).data;
    },
    listarTipoOperacion() {
      axios.get("api/TipoOperacion/Listar").then((response) => {
        //console.log(response.data);
        this.items_tipo_operacion = response.data;
      });
    },
    listarTipoIngresos() {
      axios.get("api/TipoIngresos/Listar").then((response) => {
        //console.log(response.data);
        this.items_tipo_ingreso = response.data;
      });
    },
    handleOtrosChange() {
      if (this.otros_factura) {
        this.extingido_cautelado = false;
        this.codigo_bien = "";
      }
    },
    eliminarFactura() {
      this.dialog_eliminar_factura = true;
    },
    confirmarEliminarFactura() {
      this.loading_eliminar_factura = true;
      axios
        .delete("api/Facturas/Eliminar/" + this.id_factura)
        .then(async () => {
          this.snackbar_text = "Factura eliminada exitosamente";
          this.snackbar = true;
          this.dialog_eliminar_factura = false;
          this.cerrarDialog();
          this.listarFacturas();
          this.loading_eliminar_factura = false;
          await this.actualizarBlocs("eliminar");
        })
        .catch(() => {
          this.snackbar_text = "No se pudo eliminar la factura";
          this.snackbar = true;
          this.loading_eliminar_factura = false;
        });
    },
    async actualizarBlocs(estatus) {
      await axios
        .put("api/DetallesEmpresas/ActualizarBlob", {
          id_empresa: this.$store.state.emp.id_empresa,
          blob_restante: estatus,
          blob_sumados: estatus,
        })
        .then(() => {
          return;
        });
    },
    facturasCSV() {
      this.flag_csv = "si";
    },
    async procesarCSV() {
      if (this.data_file_input.length > 0) {
        this.result_data_facturas = [];
        var flag_index = 0;
        var cont = 0;
        for (var i = 0; i < this.data_file_input.length; i++) {
          var guid = await this.obtenerGuidCSV();
          var num_control = (await this.obtenerCorrelativoTipoDocCSV(12)) + i;
          this.contador_tipo_doc_fiscal = num_control;
          var formato_ceros = "000000000000000".substring(
            0,
            15 - num_control.toString().length
          );
          Papa.parse(this.data_file_input[i], {
            header: false,
            dynamicTyping: true,
            skipEmptyLines: true,
            complete: (results) => {
              //console.log(results.data[0][0]);
              this.obtenerClienteCSV(results.data[0][0]).then((res) => {
                //console.log(res[0]);
                results.data.forEach((item) => {
                  if (item[0] != null) {
                    flag_index = cont++;
                    this.result_data_facturas.push({
                      encabezado: {
                        id_tipo_doc_fiscal: 12,
                        id_cliente: res[0].id_cliente,
                        id_empresa: this.$store.state.emp.id_empresa,
                        id_sucursal: 33,
                        numero_control:
                          "DTE-11-00000000-" + formato_ceros + num_control,
                        codigo_generacion: guid,
                        fecha: settings.metodos.formatoFechaHora(new Date()),
                        sello_recepcion: "",
                        fecha_recepcion: "",
                        anticipo: 0,
                        exentas: 0,
                        no_sujetas: 0,
                        otros_cargos: 0,
                        percepcion: 0,
                        retencion: 0,
                        iva: 0,
                        sub_total: 0,
                        cod_cliente: item[0],
                        Customer: item[1],
                        NIT: item[2],
                        LineofBusiness: item[3],
                        Country: item[4],
                        Address: item[5],
                        ciudad: item[6],
                        estado: item[7],
                        Phonenumber: item[8],
                        correo1: item[9],
                        correo2: item[10],
                        correo3: item[11],
                        consignado_a: item[12],
                        consignado_a_direccion: item[13],
                        descuento: item[14] != null ? item[14] : 0,
                        seguro: item[15] != null ? item[15] : 0,
                        transporte: item[16] != null ? item[16] : 0,
                        total_pagar: item[17],
                        tipo_pago: item[18],
                        incoterms: item[19],
                        comentario: item[20],
                        referencia: item[21],
                        sample_charge: item[22] != null ? item[22] : 0,
                        otros: item[23] != null ? item[23] : 0,
                        efficiency_surcharge: item[24] != null ? item[24] : 0,
                        light_weight_charge_money:
                          item[25] != null ? item[25] : 0,
                        bags_per_piece: item[26] != null ? item[26] : 0,
                        pais_origen: item[27],
                        total_pounds: item[28] != null ? item[28] : 0,
                        gross_weight: item[29] != null ? item[29] : 0,
                        raw_material: item[30] != null ? item[30] : 0,
                        added_value: item[31] != null ? item[31] : 0,
                        customs_total: item[32] != null ? item[32] : 0,
                        gravadas: item[17] != null ? item[17] : 0,
                        total_operacion: item[17] != null ? item[17] : 0,
                        estatus: "GUARDADO",
                        es_anulado: false,
                      },
                      detalles: [
                        {
                          cod_servicio: "01",
                          descuento: 0,
                          estilo: item[33],
                          cantidad: item[34] != null ? item[34] : 0,
                          unidad_medida: item[35],
                          descripcion: item[36],
                          descripcion2: item[37],
                          precio: item[38] != null ? item[38] : 0,
                          total: item[39] != null ? item[39] : 0,
                        },
                      ],
                    });
                  } else {
                    this.result_data_facturas[flag_index].detalles.push({
                      cod_servicio: "01",
                      descuento: 0,
                      estilo: item[33],
                      cantidad: item[34] != null ? item[34] : 0,
                      unidad_medida: item[35],
                      descripcion: item[36],
                      descripcion2: item[37],
                      precio: item[38] != null ? item[38] : 0,
                      total: item[39] != null ? item[39] : 0,
                    });
                  }
                });
              });
              //console.log(this.result_data_facturas);
            },
          });
        }
        this.items_csv = this.result_data_facturas;
      }
    },
    guardarCSV() {
      this.result_data_facturas.forEach((element) => {
        axios
          .post("api/Facturas/CrearCSV", {
            encabezado: element.encabezado,
            detalle: element.detalles,
          })
          .then(() => {
            this.incrementarCorrelativoTipoDocCSV();
          })
          .catch((e) => {
            //console.log("ERROR", e);
          });
      });
      this.flag_csv = "no";
      this.data_file_input = [];
      this.items_csv = [];
      this.file = [];
      this.listarFacturas();
    },
    async enviarDTE(item) {

      const ahora = new Date();
      const hora = ahora.getHours();
      const min = ahora.getMinutes();
      const pasoCorte = hora > 16 || (hora === 16 && min >= 0);

      if (pasoCorte) {
        this.snackbar_text =
          "Envío deshabilitado después de las 4:00 pm. Se habilitará el siguiente día.";
        this.snackbar = true;
        return;
      }

      this.loading_facturas = true;
      axios
        .post("api/ServicioRecepciones/FirmarDocumento2", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: item.cod_doc_fiscal,
          idFactura: item.id_factura,
          ambiente: await this.obtenerAmbiente(),
        })
        .then((response) => {
          if (response.data.estado == "PROCESADO") {
            this.snackbar_text =
              "FACTURA ENVIADA EXITOSAMENTE: " + response.data.descripcionMsg;
            this.snackbar_obs =
              response.data.observaciones.length > 0
                ? "Observaciones: " + response.data.observaciones
                : "Observaciones: " + "Sin observaciones";
            this.icon_snackbar = "fa-solid fa-check";
            this.snackbar_icon_color = "green";
          } else if (response.data.estado == "RECHAZADO") {
            this.snackbar_text =
              "FACTURA RECHAZADO: " + response.data.descripcionMsg;
            this.snackbar_obs =
              response.data.observaciones.length > 0
                ? "Observaciones: " + response.data.observaciones
                : "Observaciones: " + "Sin observaciones";
            this.icon_snackbar = "fa-solid fa-x";
            this.snackbar_icon_color = "red";
          }
          this.loading_facturas = false;
          this.snackbar = true;
          this.listarFacturas();
        })
        .catch(() => {
          this.loading_facturas = false;
          this.snackbar_text = "Error de solicitud";
          this.snackbar = true;
        });
    },
    async anularFactura() {
      axios
        .post("api/ServicioRecepciones/FirmarDocumento2", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: "INV",
          idFactura: this.id_factura,
          ambiente: await this.obtenerAmbiente(),
        })
        .then((response) => {
          //this.snackbar_text = "Solicitud enviada";
          this.dialog_confirmar_anular = false;
          if (response.data.estado == "PROCESADO") {
            this.snackbar_text =
              "FACTURA ENVIADA EXITOSAMENTE: " + response.data.descripcionMsg;
            this.snackbar_obs =
              response.data.observaciones.length > 0
                ? "Observaciones: " + response.data.observaciones
                : "Observaciones: " + "Sin observaciones";
          } else if (response.data.estado == "RECHAZADO") {
            this.snackbar_text =
              "FACTURA RECHAZADO: " + response.data.descripcionMsg;
            this.snackbar_obs =
              response.data.observaciones.length > 0
                ? "Observaciones: " + response.data.observaciones
                : "Observaciones: " + "Sin observaciones";
          }
          this.snackbar = true;
          this.cerrarDialog();
          this.listarFacturas();
        })
        .catch(() => {
          this.snackbar_text = "Error de solicitud";
          this.snackbar = true;
        });
    },
    async enviarDTE_v2(item) {
      this.loading_facturas = true;
      axios
        .post("api/ServicioRecepciones/FirmarDocumento2_v2", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: item.cod_doc_fiscal,
          idFactura: item.id_factura,
          ambiente: await this.obtenerAmbiente(),
        })
        .then((response) => {
          this.loading_facturas = false;
          if (response.data.estado == "PROCESADO") {
            this.snackbar_text =
              "FACTURA ENVIADA EXITOSAMENTE: " + response.data.descripcionMsg;
            this.snackbar_obs =
              response.data.observaciones.length > 0
                ? "Observaciones: " + response.data.observaciones
                : "Observaciones: " + "Sin observaciones";
          } else if (response.data.estado == "RECHAZADO") {
            this.snackbar_text =
              "FACTURA RECHAZADO: " + response.data.descripcionMsg;
            this.snackbar_obs =
              response.data.observaciones.length > 0
                ? "Observaciones: " + response.data.observaciones
                : "Observaciones: " + "Sin observaciones";
          }
          this.snackbar = true;
          this.cerrarDialog();
          this.listarFacturas();
        })
        .catch(() => {
          this.loading_facturas = false;
          this.snackbar_text = "Error de solicitud";
          this.snackbar = true;
        });
    },
    async anularFactura_v2() {
      axios
        .post("api/ServicioRecepciones/FirmarDocumento2_v2", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: "INV",
          idFactura: this.id_factura,
          ambiente: await this.obtenerAmbiente(),
        })
        .then((response) => {
          //this.snackbar_text = "Solicitud enviada";
          this.dialog_confirmar_anular = false;
          if (response.data.estado == "PROCESADO") {
            this.snackbar_text =
              "FACTURA ENVIADA EXITOSAMENTE: " + response.data.descripcionMsg;
            this.snackbar_obs =
              response.data.observaciones.length > 0
                ? "Observaciones: " + response.data.observaciones
                : "Observaciones: " + "Sin observaciones";
          } else if (response.data.estado == "RECHAZADO") {
            this.snackbar_text =
              "FACTURA RECHAZADO: " + response.data.descripcionMsg;
            this.snackbar_obs =
              response.data.observaciones.length > 0
                ? "Observaciones: " + response.data.observaciones
                : "Observaciones: " + "Sin observaciones";
          }
          this.snackbar = true;
          this.cerrarDialog();
          this.listarFacturas();
        })
        .catch(() => {
          this.snackbar_text = "Error de solicitud";
          this.snackbar = true;
        });
    },
    async vistaPreviaPdf(item) {
      //console.log(item);
      this.loading_facturas = true;

      axios
        .post("api/ServicioRecepciones/VistaPreviaDTE2", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: item.cod_doc_fiscal,
          idFactura: item.id_factura,
          ambiente: await this.obtenerAmbiente(),
          es_previo: true,
        })
        .then((response) => {
          //console.log(response.data);
          this.loading_facturas = false;
          this.base64_doc = "data:application/pdf;base64," + response.data;
          this.dialog_preview_report = true;
        })
        .catch(() => {
          this.snackbar_text = "No se pudo generar el reporte";
          this.snackbar = true;
          this.loading_facturas = false;
        });
    },
    async vistaPreviaPdfSello(item) {
      this.loading_facturas = true;
      axios
        .post("api/ServicioRecepciones/DescargarFacturaWeb", {
          cod_emp: this.$store.state.emp.id_empresa,
          tipoDte: item.cod_doc_fiscal,
          idFactura: item.id_factura,
          ambiente: await this.obtenerAmbiente(),
          es_previo: false,
        })
        .then((response) => {
          //console.log(response.data);
          this.loading_facturas = false;
          this.base64_doc = "data:application/pdf;base64," + response.data;
          this.dialog_preview_report = true;
        })
        .catch(() => {
          this.snackbar_text = "No se pudo generar el reporte";
          this.snackbar = true;
          this.loading_facturas = false;
        });
    },
    reenviarCorreo(item) {
      //console.log(item);
      axios
        .post("api/ServicioRecepciones/EnviarCorreos", {
          id_emp: item.id_empresa,
          cod_emp: this.$store.state.emp.cod_empresa,
          nom_base: "sqlserver",
          codFactura: item.codigo_generacion,
          tipoDte: item.cod_doc_fiscal,
          origen: "SQLSERVER",
        })
        .then(() => {
          this.snackbar_text = "Correo enviado";
          this.snackbar = true;
        })
        .catch(() => {
          this.snackbar_text = "Error de solicitud";
          this.snackbar = true;
        });
    },
    listarFacturas() {
      this.loading_facturas = true;
      axios
        .get("api/Facturas/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items = response.data.map((r) => {
            const cod = ((r.cod_doc_fiscal || "") + "").toUpperCase().trim();
            const preferido =
              r.nombre ?? r.cliente_nombre ?? r.nombreprov ?? "";
            return {
              ...r,
              nombre_cliente:
                cod === "CCF" ? preferido : r.nombre_cliente ?? preferido,
            };
          });
          this.loading_facturas = false;
        })
        .catch(() => {
          this.loading_facturas = false;
        });
    },
    listarUsuarioSucursal() {
      axios
        .get(
          "api/Usuarios/ListarUsuariosSucursales/" +
          this.$store.state.emp.id_empresa +
          "/" +
          this.$store.state.usuario.idUsuario
        )
        .then((response) => {
          //console.log(response.data);
          this.cod_sucursal_mh = response.data[0].cod_sucursal_mh;
          this.cod_punto_venta_mh = response.data[0].cod_punto_venta_mh;
        });
    },
    listarSucursales() {
      axios
        .get("api/Sucursales/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_sucursales = response.data;
          this.sucursal = response.data[0].id_sucursal;
          this.listarPuntosVenta("auto");
        });
    },
    listarPuntosVenta(estado) {
      axios
        .get(
          "api/PuntoVentas/ListarXsucursal/" +
          this.$store.state.emp.id_empresa +
          "/" +
          this.sucursal
        )
        .then((response) => {
          //console.log(response.data);
          this.items_punto_venta = response.data;
          this.punto_venta = response.data[0].id_punto_venta;
          this.listarTipoDocs();

          if (estado != "auto" && this.tipo_doc_fiscal == "") {
            this.cod_sucursal_mh = response.data[0].cod_sucursal_mh;
            this.cod_punto_venta_mh = response.data[0].cod_punto_venta_mh;
          } else if (estado != "auto" && this.tipo_doc_fiscal != undefined) {
            this.cod_sucursal_mh = response.data[0].cod_sucursal_mh;
            this.cod_punto_venta_mh = response.data[0].cod_punto_venta_mh;
            this.listarDocSeleccionado();
          }
        });
    },
    listarTipoDocs() {
      if (this.sucursal) {
        axios
          .get(
            "api/ConfiFacturas/Listar/" +
            this.sucursal +
            "/" +
            this.punto_venta +
            "/" +
            this.$store.state.emp.id_empresa
          )
          .then((response) => {
            this.items_tipo_doc_fiscales = response.data;

            if (
              this.flag_new_edit === 1 &&
              (!this.tipo_doc_fiscal ||
                !this.tipo_doc_fiscal.id_tipo_doc_fiscal)
            ) {
              const fac = this.items_tipo_doc_fiscales.find(
                (d) => d.cod_doc_fiscal === "FAC"
              );
              if (fac) {
                this.tipo_doc_fiscal = fac;
                this.id_tipo_doc_fiscal = fac.id_tipo_doc_fiscal;
                this.listarDocSeleccionado();
              }
            }

            if (this.flag_new_edit === 2 && this.id_tipo_doc_fiscal > 0) {
              const match = this.items_tipo_doc_fiscales.find(
                (d) => d.id_tipo_doc_fiscal === this.id_tipo_doc_fiscal
              );
              if (match) {
                this.tipo_doc_fiscal = match;
                this.listarDocSeleccionado();
              }
            }

            this.llamarCalculo();
          });
      }
    },

    llamarCalculo() {
      this.limpiarCalculosCabecera();

      const cod = (
        (this.tipo_doc_fiscal && this.tipo_doc_fiscal.cod_doc_fiscal) ||
        ""
      ).toUpperCase();

      for (const it of this.items_productos) {
        const cant = Number(it.cantidad || 0);
        const precioLinea = Number(it.precio || 0);
        const descPct = Number(it.descuento || 0);

        if (cant <= 0) continue;

        const totalNeto = Number(it.total || 0);
        const totalConIva = it.con_iva ? Number(it.total_con_iva || 0) : 0;
        const totalLinea = Number(it.total_con_iva || 0);

        const bruto = cant * precioLinea;
        const desc = bruto * (descPct / 100);
        this.descuento = (Number(this.descuento) + desc).toFixed(2);

        if (this.cliente_exento || it.exento) {
          // Solo separa en EXENTAS y no calcula IVA ni GRAVADAS
          this.exentas = (Number(this.exentas) + totalLinea).toFixed(2);
          continue;
        }

        if (it.no_sujeto) {
          this.no_sujetas = (Number(this.no_sujetas) + totalLinea).toFixed(2);
          continue;
        }

        if (cod === "CCF" && it.con_iva) {
          const base = Number((it.total || 0).toFixed(2));
          const ivaLinea = Number(
            ((it.total_con_iva || 0) - (it.total || 0)).toFixed(2)
          );

          this.gravadas = (Number(this.gravadas) + base).toFixed(2);
          this.iva = (Number(this.iva) + ivaLinea).toFixed(2);
        } else {
          this.gravadas = (Number(this.gravadas) + totalNeto).toFixed(2);
        }
      }

      // Sub-total
      this.sub_total = (
        Number(this.gravadas) +
        Number(this.exentas) +
        Number(this.no_sujetas)
      ).toFixed(2);

      // RETENCIÓN
      this.retencion = 0;
      if (this.cliente_retencion && Number(this.gravadas) >= 100) {
        if (cod === "FAC") {
          this.retencion = ((Number(this.gravadas) / 1.13) * 0.01).toFixed(2);
        } else {
          this.retencion = (Number(this.gravadas) * 0.01).toFixed(2);
        }
      }

      // PERCEPCIÓN
      this.percepcion = 0;
      if (this.cliente_percepcion && Number(this.gravadas) >= 100) {
        this.percepcion = (Number(this.gravadas) * 0.01).toFixed(2);
      }
    },

    calculoIva(v_gravadas) {
      const base = Number(v_gravadas || 0);
      this.iva = (base * 0.13).toFixed(4);
    },
    listarClientes() {
      axios
        .get("api/Clientes/ListarTodos/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_clientes = response.data;
          if (
            this.flag_new_edit === 1 &&
            (!this.id_cliente || this.id_cliente === 0) &&
            !this.cliente
          ) {
            // Cliente por defecto X
            let def = this.items_clientes.find((obj) => obj.id_cliente == 3472);

            if (!def) {
              def = this.items_clientes.find((obj) => obj.cliente_x === true);
            }

            if (def) {
              this.cliente = def;
              this.id_cliente = def.id_cliente;
            }
          }
        });
    },
    nuevaFactura() {
      this.fecha_hora = settings.metodos.formatoFechaHora(new Date());
      this.nom_usuario = this.$store.state.usuario.nombre;
      this.obtenerGuid();
      this.flag_new_edit = 1;
      this.dialog = true;
    },
    async obtenerGuidCSV() {
      return await (
        await axios.get("api/Facturas/GenerarGuid")
      ).data;
    },
    obtenerGuid() {
      axios.get("api/Facturas/GenerarGuid").then((response) => {
        this.codigo_generacion = response.data;
      });
    },
    asignarProducto() {
      axios
        .get(
          "api/Servicios/ObtenerServicioPorCodigo/" +
          this.producto +
          "/" +
          this.$store.state.emp.id_empresa
        )
        .then((response) => {
          const srv = response.data;
          if (!srv) return;

          const cod = (this.tipo_doc_fiscal.cod_doc_fiscal || "").toUpperCase();

          if (cod === "FAC" || cod === "FEX") {
            this.precio = Number(srv.precio).toFixed(2);
            this.precio_con_iva = this.precio;
          } else if (cod === "CCF") {
            if (srv.con_iva) {
              const p = Number(srv.precio);
              this.precio = p.toFixed(2);
              this.precio_con_iva = p.toFixed(2);
            } else {
              const base = Number(srv.precio);
              this.precio = base.toFixed(2);
              this.precio_con_iva = base.toFixed(2);
            }
          } else {
            this.precio = Number(srv.precio).toFixed(2);
            this.precio_con_iva = this.precio;
          }

          this.flag_servicio = srv == "" ? true : false;
          this.descripcion = srv.nom_servicio;
          this.total = (Number(this.precio) * Number(this.cantidad)).toFixed(2);
          this.exento_prod = srv.exento;
          this.no_sujeto_prod = srv.no_sujeto;
          this.con_iva_prod = !!srv.con_iva;
        });
    },

    calculoDescuento() {
      var entero = Number.isInteger(Number(this.descuento_prod));
      if (this.descuento_prod > 10) {
        this.descuento_prod = 10;
      } else if (!entero) {
        this.descuento_prod = 0;
      } else if (this.descuento_prod == "") {
        this.descuento_prod = 0;
      }

      var total_item = Number(this.cantidad) * Number(this.precio);
      this.monto_descuento = 0;

      this.monto_descuento =
        Number(this.cantidad) *
        Number(this.precio) *
        (Number(this.descuento_prod) / 100);
      this.total = (Number(total_item) - Number(this.monto_descuento)).toFixed(
        2
      );
    },
    setCliente() {
      this.id_cliente = this.cliente.id_cliente;
      this.nombre = this.cliente.nombre;
      this.registro = this.cliente.registro;
      this.identifiador = this.cliente.identificador_nombre;
      this.telefono = this.cliente.telefono;
      this.tipo = this.cliente.tipo_persona;
      this.cliente_exento = this.cliente.exento;
      this.cliente_retencion = this.cliente.con_retencion;
      this.cliente_percepcion = this.cliente.con_percepcion;
      this.cliente_tamaño = this.cliente.tamaño;
      this.cliente_extranjero = this.cliente.extranjero;
      this.num_documento = this.cliente.documento;

      this.nombre_cliente = this.cliente.nombre || "";

      this.llamarCalculo();
      //this.listarClientes();
      this.dialog_clientes = false;
    },
    obtenerClienteCSV(cod_cliente) {
      var id = axios
        .get(
          "api/Clientes/ListarXcod/" +
          this.$store.state.emp.id_empresa +
          "/" +
          cod_cliente
        )
        .then((res) => {
          //console.log(res.data);
          return res.data;
        });
      return id;
    },
    listarServicios() {
      axios
        .get("api/Servicios/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          //console.log(response.data);
          this.items_servicios = response.data;
        });
    },
    setServicio(event, { item }) {
      const cod = (this.tipo_doc_fiscal.cod_doc_fiscal || "").toUpperCase();

      if (cod === "FAC" || cod === "FEX") {
        this.precio = Number(item.precio).toFixed(2);
        this.precio_con_iva = this.precio;
      } else if (cod === "CCF") {
        if (item.con_iva) {
          const p = Number(item.precio); // precio CON IVA
          this.precio = p.toFixed(2);
          this.precio_con_iva = p.toFixed(2);
        } else {
          const base = Number(item.precio); // sin IVA
          this.precio = base.toFixed(2);
          this.precio_con_iva = base.toFixed(2);
        }
      } else {
        this.precio = Number(item.precio).toFixed(2);
        this.precio_con_iva = this.precio;
      }

      this.producto = item.cod_servicio;
      this.descripcion = item.nom_servicio;
      this.total = (Number(this.precio) * Number(this.cantidad)).toFixed(2);
      this.exento_prod = item.exento;
      this.no_sujeto_prod = item.no_sujeto;
      this.con_iva_prod = !!item.con_iva;

      this.dialog_servicios = false;
    },

    agregarProducto() {
      if (!this.cliente || !this.tipo_doc_fiscal) {
        this.snackbar_text =
          "Debe de seleccionar el tipo de documento fiscal y el cliente";
        this.snackbar = true;
        return;
      }

      if (
        this.tipo_doc_fiscal.cod_doc_fiscal == "FEX" &&
        !this.cliente_extranjero
      ) {
        this.snackbar_text = "El cliente no es extranjero";
        this.snackbar = true;
        return;
      }

      if (!this.producto) {
        this.snackbar_text = "El campo producto no puede ir vacío";
        this.snackbar = true;
        return;
      }

      if (this.id_detalle_factura == -1) {
        const index = this.items_productos.findIndex((it) => it.id == this.id);
        if (index != -1) {
          this.editarDetalleServicio(index);
          return;
        }
      } else if (this.id_detalle_factura > 0) {
        const index = this.items_productos.findIndex(
          (it) => it.id_detalle_factura == this.id_detalle_factura
        );
        if (index != -1) {
          this.editarDetalleServicio(index);
          return;
        }
      }

      this.cont_prod++;

      const codDoc = (
        (this.tipo_doc_fiscal && this.tipo_doc_fiscal.cod_doc_fiscal) ||
        ""
      ).toUpperCase();

      const esExentoLinea =
        this.exento_prod || this.no_sujeto_prod || this.cliente_exento;

      let precioConIVA = Number(this.precio || 0);
      let precioSinIVA = precioConIVA;
      let conIvaLinea =
        this.con_iva_prod !== undefined && this.con_iva_prod !== null
          ? !!this.con_iva_prod
          : codDoc === "CCF";

      if (esExentoLinea) {
        precioSinIVA = precioConIVA;
        conIvaLinea = false;
      } else {
        if (codDoc === "CCF" && conIvaLinea) {
          precioSinIVA = Number((precioConIVA / 1.13).toFixed(4));
          console.log("Precio con IVA: " + precioConIVA);

        } else {
          precioSinIVA = precioConIVA;
        }
      }

      const totalSinIVA = this.cantidad * precioSinIVA;
      const totalConIVA = this.cantidad * precioConIVA;

      this.items_productos.push({
        id: this.cont_prod,
        id_detalle_factura: -1,
        cantidad: this.cantidad,
        cod_servicio: this.producto,
        descripcion: this.descripcion,
        precio: precioSinIVA,
        precio_con_iva: precioConIVA,
        descuento: this.descuento_prod,
        total: totalSinIVA,
        total_con_iva: totalConIVA,
        exento: this.exento_prod,
        no_sujeto: this.no_sujeto_prod,
        con_iva: conIvaLinea,
      });

      this.recalcular_automatico = true;
      this.llamarCalculo();
      this.limpiarCamposProductos();
    },

    editarDetalleServicio(index) {
      const cant = Number(this.cantidad || 0);
      const codDoc = (
        (this.tipo_doc_fiscal && this.tipo_doc_fiscal.cod_doc_fiscal) ||
        ""
      ).toUpperCase();

      const esExentoLinea =
        this.exento_prod || this.no_sujeto_prod || this.cliente_exento;

      let precioConIVA = Number(this.precio || 0);
      let precioSinIVA = precioConIVA;
      let conIvaLinea = !!this.con_iva_prod;

      if (esExentoLinea) {
        precioSinIVA = precioConIVA;
        conIvaLinea = false;
      } else {
        if (codDoc === "CCF" && conIvaLinea) {
          precioSinIVA = Number((precioConIVA / 1.13).toFixed(2));
        } else {
          precioSinIVA = precioConIVA;
        }
      }

      const descPct = Number(this.descuento_prod || 0);
      const brutoLinea = cant * precioSinIVA;
      const descLinea = brutoLinea * (descPct / 100);
      const totalLinea = (brutoLinea - descLinea).toFixed(2);

      this.items_productos[index].cantidad = cant;
      this.items_productos[index].cod_servicio = this.producto;
      this.items_productos[index].descripcion = this.descripcion;
      this.items_productos[index].precio = precioSinIVA;
      this.items_productos[index].precio_con_iva = precioConIVA;
      this.items_productos[index].descuento = descPct;
      this.items_productos[index].total = totalLinea;
      this.items_productos[index].total_con_iva = cant * precioConIVA;
      this.items_productos[index].exento = this.exento_prod;
      this.items_productos[index].no_sujeto = this.no_sujeto_prod;
      this.items_productos[index].con_iva = conIvaLinea;

      this.id_detalle_factura = 0;

      this.llamarCalculo();
      this.limpiarCamposProductos();
    },

    sumarSubTotales(v_total) {
      this.sub_total = parseFloat(
        Number(this.sub_total) + Number(v_total)
      ).toFixed(2);
    },
    sumarDescuentos() {
      if (this.descuento_prod > 0) {
        this.flag_descuento = true;
      }
      this.descuento = parseFloat(
        Number(this.descuento) + Number(this.monto_descuento)
      ).toFixed(4);
    },
    calculoGravadas(v_sub_total, v_descuento) {
      this.gravadas = parseFloat(Number(v_sub_total)).toFixed(4);
    },
    calculoIva(v_gravadas) {
      const base = Number(v_gravadas || 0);
      this.iva = (base * 0.13).toFixed(4);
    },
    calculoExento(v_total) {
      this.exentas = (Number(this.exentas) + Number(v_total)).toFixed(4);
    },
    calculoNoSujeto() {
      this.no_sujetas = (Number(this.no_sujetas) + Number(this.total)).toFixed(
        4
      );
    },
    editarFactura(item) {
      //console.log(item);
      this.id_factura = item.id_factura;
      this.id_tipo_doc_fiscal = item.id_tipo_doc_fiscal;
      this.tipo_doc_fiscal = item;
      this.id_cliente = item.id_cliente;
      this.id_empresa = item.id_empresa;
      this.sucursal = item.id_sucursal;
      this.numero_control = item.numero_control;
      this.codigo_generacion = item.codigo_generacion;
      this.fecha_hora = item.fecha;
      this.sello_recepcion = item.sello_recepcion;
      this.fecha_recepcion = item.fecha_recepcion;
      this.tipo_pago = item.tipo_pago;
      this.otros_cargos = item.otros_cargos;
      this.anticipo = item.anticipo;
      this.sub_total = item.sub_total;
      this.descuento = item.descuento;
      this.gravadas = item.gravadas;
      this.iva = item.iva;
      this.exentas = item.exentas;
      this.no_sujetas = item.no_sujetas;
      this.retencion = item.retencion;
      this.percepcion = item.percepcion;
      this.total_operacion = item.total_operacion;
      this.total_pagar = item.total_pagar;
      this.codigo_bien = item.codigo_bien;
      this.extingido_cautelado = item.extingido_cautelado;
      this.otros_factura = item.otros_factura;
      this.consignado_a = item.consignado_a;
      this.id_usuario = item.id_usuario;
      this.nom_usuario = item.nom_usuario;
      this.tipo_operacion = item.tipo_operacion;
      this.tipo_ingreso = item.tipo_ingreso;
      this.paciente = item.nombre_paciente;

      this.cliente = item.cliente_codigo;
      this.nombre = item.cliente_nombre;
      this.registro = item.cliente_registro;
      this.identifiador = item.cliente_identificador;
      this.telefono = item.cliente_telefono;
      this.tipo = item.cliente_tipo;
      this.cliente_exento = item.cliente_exento;
      this.cliente_retencion = item.cliente_retencion;
      this.cliente_percepcion = item.cliente_percepcion;
      this.nombre_cliente = item.nombre_cliente;

      this.listarDetallesfactura();

      this.flag_new_edit = 2;
      this.dialog = true;
    },
    eliminarDetalleFactura(item) {
      this.item_servicio_eliminar = item;
      this.dialog_eliminar_servicio = true;
    },
    confirmarEliminarDetalleFactura() {
      const item = this.item_servicio_eliminar;

      if (item.id_detalle_factura > 0) {
        axios
          .delete("api/DetallesFacturas/Eliminar/" + item.id_detalle_factura)
          .then(() => {
            const index = this.items_productos.findIndex(
              (it) => it.id_detalle_factura == item.id_detalle_factura
            );
            if (index != -1) this.items_productos.splice(index, 1);

            this.llamarCalculo();
            this.dialog_eliminar_servicio = false;
            this.snackbar_text = "Servicio eliminado";
            this.snackbar = true;
          })
          .catch(() => {
            this.snackbar_text = "Servicio no se pudo eliminar";
            this.snackbar = true;
          });
      } else {
        const index = this.items_productos.findIndex((it) => it.id == item.id);
        if (index != -1) this.items_productos.splice(index, 1);

        this.recalcular_automatico = true;
        this.llamarCalculo();
        this.dialog_eliminar_servicio = false;
        this.snackbar_text = "Servicio eliminado";
        this.snackbar = true;
      }
    },

    editarProducto(item) {
      this.id = item.id;
      this.id_detalle_factura = item.id_detalle_factura;
      this.cantidad = item.cantidad;
      this.producto = item.cod_servicio;
      this.descripcion = item.descripcion;
      this.precio = item.precio_con_iva;
      this.precio_con_iva = item.precio_con_iva || 0;
      this.descuento_prod = item.descuento;
      this.total = item.total;
      this.exento_prod = item.exento;
      this.no_sujeto_prod = item.no_sujeto;
      this.con_iva_prod = item.con_iva || false;
    },

    async crearfactura() {
      var obj_blocs = await (
        await axios.get(
          "api/DetallesEmpresas/VerificarBlob/" +
          this.$store.state.emp.id_empresa
        )
      ).data;
      //console.log(obj_blocs[0]);
      if (obj_blocs[0].bloc) {
        if (obj_blocs[0].bloc_restante == 0) {
          this.snackbar_text =
            "No se pueden crear más facturas, ha llegado al limite de facturas creadas";
          this.snackbar = true;
          return;
        }
      }

      var items_detalles_factura_ncr = [];
      var items_facturas_ndb = [];

      if (this.total_pagar == 0) {
        this.snackbar_text = "El total no debe de ir a cero";
        this.snackbar = true;
        return;
      }

      for (var i = 0; i < this.items_productos.length; i++) {
        if (this.tipo_doc_fiscal.cod_doc_fiscal == "NCR") {
          items_detalles_factura_ncr.push({
            cantidad: this.items_productos[i].cantidad,
            cod_servicio: this.items_productos[i].cod_servicio,
            descripcion: this.items_productos[i].descripcion,
            precio: this.items_productos[i].precio,
            precio_con_iva: this.items_productos[i].precio_con_iva,
            descuento: this.items_productos[i].descuento,
            total: this.items_productos[i].total,
            exento: this.items_productos[i].exento,
            no_sujeto: this.items_productos[i].no_sujeto,
            id_detalle_factura_ncr: this.items_productos[i].id_detalle_factura,
          });

          var index = this.items_tipo_doc_ncr_ndb.findIndex(
            (item) => item.id_factura == this.items_productos[i].id_factura
          );
          if (index == -1) {
            this.items_tipo_doc_ncr_ndb.push({
              id_empresa: this.$store.state.emp.id_empresa,
              id_factura_relacionado: this.items_productos[i].id_factura,
            });
          }
        } else {
          items_detalles_factura_ncr.push(this.items_productos[i]);
        }
      }

      for (var i = 0; i < this.items_tipo_doc_ncr_ndb.length; i++) {
        items_facturas_ndb.push({
          id_empresa: this.$store.state.emp.id_empresa,
          id_factura_relacionado:
            this.items_tipo_doc_ncr_ndb[i].id_factura_relacionado,
        });
      }

      if (items_detalles_factura_ncr.length == 0) {
        this.snackbar_text = "No puede guardar sin detalles";
        this.snackbar = true;
        return;
      }

      this.loading_guardar = true;
      axios
        .post("api/Facturas/Crear", {
          id_tipo_doc_fiscal: this.tipo_doc_fiscal.id_tipo_doc_fiscal,
          id_cliente: this.id_cliente,
          id_empresa: this.$store.state.emp.id_empresa,
          id_sucursal: this.sucursal,
          id_punto_venta: this.punto_venta,
          numero_control: this.numero_control,
          codigo_generacion: this.codigo_generacion,
          fecha: this.fecha_hora,
          sello_recepcion: this.sello_recepcion,
          fecha_recepcion: this.fecha_recepcion,
          tipo_pago: this.tipo_pago,
          otros_cargos: this.otros_cargos,
          anticipo: this.anticipo,
          sub_total: this.sub_total,
          descuento: this.descuento,
          gravadas: this.gravadas,
          iva: this.iva,
          exentas: this.exentas,
          no_sujetas: this.no_sujetas,
          retencion: this.retencion,
          percepcion: this.percepcion,
          total_operacion: this.total_operacion,
          total_pagar: this.total_pagar,
          es_anulado: false,
          estatus: "GUARDADO",
          ciudad: "",
          estado: "",
          Phonenumber: "",
          correo1: "",
          correo2: "",
          correo3: "",
          consignado_a: "",
          consignado_a_direccion: "",
          seguro: 0.0,
          transporte: 0.0,
          incoterms: "",
          comentario: "",
          referencia: "",
          sample_charge: 0.0,
          otros: 0.0,
          efficiency_surcharge: 0.0,
          light_weight_charge_money: 0.0,
          bags_per_piece: 0.0,
          pais_origen: "",
          total_pounds: 0.0,
          gross_weight: 0.0,
          raw_material: 0.0,
          added_value: 0.0,
          customs_total: 0.0,
          codigo_bien: this.codigo_bien,
          extingido_cautelado: this.extingido_cautelado,
          otros_factura: this.otros_factura,
          detalleFactura: items_detalles_factura_ncr,
          detalleNDB_NCR: items_facturas_ndb,
          id_usuario: this.$store.state.usuario.idUsuario,
          tipo_operacion: this.tipo_operacion,
          tipo_ingreso: this.tipo_ingreso,
          saldo: this.total_pagar,
          observaciones: this.observaciones,
          nombre_cliente: this.nombre_cliente,
        })
        .then(async () => {
          this.snackbar_text = "Registro creado con exito";
          this.snackbar = true;
          this.loading_guardar = false;
          this.escucharServer();
          await this.actualizarBlocs("nuevo");
          this.cerrarDialog();
          this.listarFacturas();
        })
        .catch(() => {
          this.snackbar_text = "Sucedio algún error";
          this.snackbar = true;
          this.loading_guardar = false;
        });
    },
    actualizarfactura() {
      var items_facturas_ndb = [];
      for (var i = 0; i < this.items_tipo_doc_ncr_ndb.length; i++) {
        items_facturas_ndb.push({
          id_empresa: this.$store.state.emp.id_empresa,
          id_factura_relacionado:
            this.items_tipo_doc_ncr_ndb[i].id_factura_relacionado,
        });
      }

      axios
        .put("api/Facturas/Actualizar", {
          id_factura: this.id_factura,
          id_tipo_doc_fiscal: this.tipo_doc_fiscal.id_tipo_doc_fiscal,
          id_cliente: this.id_cliente,
          id_empresa: this.$store.state.emp.id_empresa,
          id_sucursal: this.sucursal,
          id_punto_venta: this.punto_venta,
          numero_control: this.numero_control,
          codigo_generacion: this.codigo_generacion,
          fecha: this.fecha_hora,
          sello_recepcion: this.sello_recepcion,
          fecha_recepcion: this.fecha_recepcion,
          tipo_pago: this.tipo_pago,
          otros_cargos: this.otros_cargos,
          anticipo: this.anticipo,
          sub_total: this.sub_total,
          descuento: this.monto_descuento,
          gravadas: this.gravadas,
          iva: this.iva,
          exentas: this.exentas,
          no_sujetas: this.no_sujetas,
          retencion: this.retencion,
          percepcion: this.percepcion,
          total_operacion: this.total_operacion,
          total_pagar: this.total_pagar,
          estatus: "GUARDADO",
          ciudad: "",
          estado: "",
          Phonenumber: "",
          correo1: "",
          correo2: "",
          correo3: "",
          consignado_a: "",
          consignado_a_direccion: "",
          seguro: 0.0,
          transporte: 0.0,
          incoterms: "",
          comentario: "",
          referencia: "",
          sample_charge: 0.0,
          otros: 0.0,
          efficiency_surcharge: 0.0,
          light_weight_charge_money: 0.0,
          bags_per_piece: 0.0,
          pais_origen: "",
          total_pounds: 0.0,
          gross_weight: 0.0,
          raw_material: 0.0,
          added_value: 0.0,
          customs_total: 0.0,
          codigo_bien: this.codigo_bien,
          extingido_cautelado: this.extingido_cautelado,
          otros_factura: this.otros_factura,
          detalleFactura: this.items_productos,
          detalleNDB_NCR: items_facturas_ndb,
          id_usuario: this.id_usuario,
          tipo_operacion: this.tipo_operacion,
          tipo_ingreso: this.tipo_ingreso,
          observaciones: this.observaciones,
          nombre_cliente: this.nombre_cliente,
        })
        .then(() => {
          this.snackbar_text = "Registro actualizado con exito";
          this.snackbar = true;
          this.escucharServer();
          this.cerrarDialog();
          this.listarFacturas();
        })
        .catch(() => {
          this.snackbar_text = "Sucedio algún error";
          this.snackbar = true;
        });
    },
    confirmarAnularDocumento() {
      this.dialog_confirmar_anular = true;
    },    
    listarDetallesfactura() {
      axios.get("api/Detallesfacturas/Listar/" + this.id_factura).then((response) => {
        this.cont_prod = 0;
        this.items_productos = (response.data || []).map((d) => ({
          ...d,
          id: ++this.cont_prod,
        }));
      });
    },
    limpiarCamposProductos() {
      this.cantidad = 1;
      this.producto = "";
      this.descripcion = "";
      this.precio = 0;
      this.precio_sin_iva = 0;
      this.descuento_prod = 0;
      this.con_iva_prod = null;
      this.total = 0;
    },
    limpiarCalculosCabecera() {
      this.otros_cargos = 0;
      this.anticipo = 0;
      this.sub_total = 0;
      this.descuento = 0;
      this.gravadas = 0;
      this.iva = 0;
      this.exentas = 0;
      this.no_sujetas = 0;
      this.retencion = 0;
      this.percepcion = 0;
      this.total_operacion = 0;
      this.total_pagar = 0;
    },
    cerrarDialog() {
      this.dialog = false;
      this.limpiar();
    },
    limpiar() {
      this.id_tipo_doc_fiscal = 0;
      this.numero_control = "DTE-00-00000000-000000000000000";
      this.fecha_hora = "";
      this.codigo_generacion = "";
      this.sello_recepcion = "";
      this.fecha_recepcion = "";
      this.tipo_doc_fiscal = "";
      this.tipo_pago = "CONTADO";
      this.id_cliente = 0;
      this.cliente = "";
      this.nombre = "";
      this.registro = "";
      this.nombre_cliente = "CLIENTE X";
      this.identifiador = "";
      this.telefono = "";
      this.tipo = "";
      this.cliente_exento = "";
      this.cliente_retencion = "";
      this.cliente_percepcion = "";
      this.cliente_tamaño = "";
      this.cantidad = 1;
      this.producto = "";
      this.descripcion = "";
      this.precio = 0;
      this.precio_sin_iva = 0;
      this.descuento = 0;
      this.monto_descuento = 0;
      this.total = 0;
      this.items_productos = [];
      this.otros_cargos = 0;
      this.anticipo = 0;
      this.sub_total = 0;
      this.gravadas = 0;
      this.iva = 0;
      this.exentas = 0;
      this.no_sujetas = 0;
      this.retencion = 0;
      this.percepcion = 0;
      this.total_operacion = 0;
      this.total_pagar = 0;
      this.id_detalle_factura = 0;
      this.cont_prod = 0;
      this.flag_new_edit = 1;
      this.codigo_bien = "";
      this.extingido_cautelado = false;
      this.otros_factura = false;
      this.items_tipo_doc_ncr_ndb = [];
      this.mes = "";
      this.resolucion_invalidacion = null;
      this.observaciones = "";
      this.recalcular_automatico = true;
      this.fecha_anexo = "";

      this.listarTipoDocs();
      this.listarClientes();
    },
    async obtenerCorrelativoTipoDocCSV(id) {
      return await (
        await axios.get(
          "api/ConfiFacturas/ListarSeleccionado/" +
          id +
          "/" +
          this.$store.state.emp.id_empresa
        )
      ).data.correlativo;
    },
    listarDocSeleccionado() {
      var formato = "DTE-";
      var formato_ceros =
        "-" +
        this.cod_sucursal_mh +
        this.cod_punto_venta_mh +
        "-000000000000000";
      var correlativo_length = "";
      var id = 0;

      if (this.tipo_doc_fiscal.id_tipo_doc_fiscal != undefined) {
        id = this.tipo_doc_fiscal.id_tipo_doc_fiscal;
      } else {
        id = this.id_tipo_doc_fiscal;
      }

      axios
        .get(
          "api/ConfiFacturas/ListarSeleccionado/" +
          id +
          "/" +
          this.$store.state.emp.id_empresa +
          "/" +
          this.sucursal +
          "/" +
          this.punto_venta
        )
        .then((response) => {
          //console.log(response.data);
          this.items_tipo_doc_fiscal = response.data;

          correlativo_length = response.data[0].correlativo.toString().length;

          formato_ceros = formato_ceros.substring(
            0,
            formato_ceros.length - correlativo_length
          );

          this.numero_control = formato
            .concat(response.data[0].cod_mh_doc_fiscal)
            .concat(formato_ceros)
            .concat(response.data[0].correlativo);
        });
    },
    incrementarCorrelativoTipoDocCSV() {
      axios
        .put("api/ConfiFacturas/IncrementarCSV", {
          id_tipo_doc_fiscal: 12,
          id_empresa: this.$store.state.emp.id_empresa,
          valor: Number(this.contador_tipo_doc_fiscal) + 1,
        })
        .then(() => {
          this.cerrarDialog();
          this.listarFacturas();
        });
    },
    incrementarCorrelativoTipoDoc() {
      axios
        .put("api/ConfiFacturas/Incrementar", {
          id_confi_factura: this.tipo_doc_fiscal.id_confi_factura,
          id_empresa: this.$store.state.emp.id_empresa,
          valor: Number(this.tipo_doc_fiscal.correlativo) + 1,
        })
        .then(() => {
          this.cerrarDialog();
          this.listarFacturas();
        });
    },
    formatoFecha(item) {
      return settings.metodos.formatoFechaHora(item);
    },
    listarCCF() {
      if (this.id_cliente <= 0) {
        this.snackbar_text = "Debe de selecionar un cliente primero.";
        this.snackbar = true;
        return;
      }

      axios
        .get(
          "api/Facturas/ListarParaNcrNdb/" +
          this.$store.state.emp.id_empresa +
          "/" +
          this.id_cliente
        )
        .then((response) => {
          this.items_ccf = response.data;

          this.dialog_tabla_CCF = true;
        });

      if (this.id_factura > 0) {
        axios
          .get(
            "api/DetalleNDB_NCR/Listar/" +
            this.id_factura +
            "/" +
            this.$store.state.emp.id_empresa
          )
          .then((response) => {
            this.lista_nrc_ndb_guardados = response.data;
          });
      }
    },
    listarServiciosDocNCR(item) {
      var format_date_now = settings.metodos.formatoFecha(new Date());
      var format_date_ccf = settings.metodos.formatoFecha(item.fecha);

      var date_now = new Date(format_date_now);
      var date_ccf = new Date(format_date_ccf);

      var milliseconds = Math.abs(date_now - date_ccf);
      var days = Math.ceil(milliseconds / (1000 * 60 * 60 * 24));
      if (days > 120) {
        this.snackbar_text = "Ya han pasado mas de 120 días para este doc.";
        this.snackbar = true;
        return;
      }

      axios
        .get("api/DetallesFacturas/Listar/" + item.id_factura)
        .then((response) => {
          this.items_detalles_fac = response.data;

          this.dialog_tabla_detalles_fac = true;
        });
    },
    agregarServiciosDocNCR() {
      this.recalcular_automatico = true;
      this.limpiarCalculosCabecera();
      for (var i = 0; i < this.items_productos.length; i++) {
        if (this.cliente_exento) {
          this.calculoExento(this.items_productos[i].total);
          return;
        }

        if (this.items_productos[i].exento) {
          this.calculoExento(this.items_productos[i].total);
          continue;
        }
        if (this.items_productos[i].no_sujeto) {
          this.calculoNoSujeto();
          continue;
        }

        //calculo sub total
        this.sub_total = (
          Number(this.sub_total) + Number(this.items_productos[i].total)
        ).toFixed(4);

        //calculo descuento
        this.monto_descuento = 0;
        this.monto_descuento =
          Number(this.items_productos[i].cantidad) *
          Number(this.items_productos[i].precio) *
          (Number(this.items_productos[i].descuento) / 100);
        this.descuento = Number(this.descuento) + Number(this.monto_descuento);

        //calculo gravadas
        this.gravadas = (
          Number(this.sub_total) - Number(this.descuento)
        ).toFixed(4);

        //calculo iva
        if (
          this.tipo_doc_fiscal.cod_doc_fiscal == "CCF" ||
          this.tipo_doc_fiscal.cod_doc_fiscal == "NCR" ||
          this.tipo_doc_fiscal.cod_doc_fiscal == "NDB" ||
          this.tipo_doc_fiscal.cod_doc_fiscal == "NRM"
        ) {
          this.calculoIva(this.gravadas);
        }

        //retencion
        if (this.cliente_retencion) {
          if (element.total >= 100) {
            this.retencion = (Number(element.total) * Number(0.01)).toFixed(4);
          }
        }

        //percepcion
        if (this.cliente_percepcion) {
          if (element.total >= 100) {
            this.percepcion = (Number(element.total) * Number(0.01)).toFixed(4);
          }
        }
      }

      this.dialog_tabla_detalles_fac = false;
    },
    colorTablaCCF(item) {
      if (this.flag_new_edit == 1) {
        return "";
      } else {
        var index = this.lista_nrc_ndb_guardados.findIndex(
          (i) => i.id_factura_relacionado == item.id_factura
        );
        if (index > -1) {
          return "green";
        }
      }
    },
    colorTablaDetalles(item) {
      if (this.flag_new_edit == 1) {
        return "white";
      } else {
        var index = this.items_productos.findIndex(
          (i) => i.id_detalle_factura_ncr == item.id_detalle_factura
        );
        if (index > -1) {
          return "green";
        }
      }
    },

    listarMes() {
      axios.get("api/Mes/Listar").then((response) => {
        this.items_mes = response.data;
      });
    },

    getClienteByIdLocal(id_cliente) {
      return (
        this.items_clientes.find((c) => c.id_cliente === id_cliente) || null
      );
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${day}/${month}/${year}`;
    },

    fechaLimiteDebitoCredito(obj) {
      var format_date_now = settings.metodos.formatoFecha(new Date());
      var format_date_ccf = settings.metodos.formatoFecha(obj.fecha);

      var date_now = new Date(format_date_now);
      var date_ccf = new Date(format_date_ccf);

      var milliseconds = Math.abs(date_now - date_ccf);
      var days = Math.ceil(milliseconds / (1000 * 60 * 60 * 24));
      if (days > 90) {
        return true;
      } else {
        return false;
      }
    },

    dialogNuevoCliente() {
      this.dialog_crear_editar_cliente = true;
      this.estado_crear_editar_cliente = 0;
    },

    dialogEditarCliente() {
      this.dialog_crear_editar_cliente = true;
      this.estado_crear_editar_cliente = this.id_cliente;
    },
    onSeleccionServicio(nomServicio) {
      const srv = this.items_busqueda_servicios.find(
        (s) => s.nom_servicio === nomServicio
      );

      if (!srv) {
        this.producto = "s-01";
        this.precio = 0;
        this.precio_con_iva = 0;
        this.total = 0;
        this.exento_prod = false;
        this.no_sujeto_prod = false;
        return;
      }

      const cod = (
        (this.tipo_doc_fiscal && this.tipo_doc_fiscal.cod_doc_fiscal) ||
        ""
      ).toUpperCase();

      const esExento = srv.exento || srv.no_sujeto;

      if (esExento) {
        const precioFinal = Number(srv.precio_con_iva || srv.precio);

        this.precio = precioFinal.toFixed(4);
        this.precio_con_iva = this.precio;
      } else if (cod === "FAC") {
        const p = Number(srv.precio);
        this.precio = p.toFixed(4);
        this.precio_con_iva = this.precio;
      } else if (cod === "CCF") {
        if (srv.con_iva) {
          const p = Number(srv.precio);
          this.precio = p.toFixed(4);
          this.precio_con_iva = p.toFixed(4);
        } else {
          const base = Number(srv.precio);
          this.precio_con_iva = base.toFixed(4);
          this.precio = Number(base * 1.13).toFixed(4);
        }
      } else {
        this.precio = (Number(srv.precio) / 1.13).toFixed(4);
        this.precio_con_iva = this.precio;
        coonsole.log("Precio sin IVA:", this.precio);
      }

      this.producto = srv.cod_servicio;
      this.total = (Number(this.precio) * Number(this.cantidad)).toFixed(2);
      this.exento_prod = srv.exento;
      this.no_sujeto_prod = srv.no_sujeto;
    },

    //Corte Caja
    cortecaja() {
      this.dialog_anexo = true;
    },

    cerrarDialogAnexo() {
      this.dialog_anexo = false;
      this.limpiar();
    },

    descargarArchivo(tipo) {
      if (tipo === "pdf") {
        this.descargarFacturas("pdf");
      }
      this.dialog_anexo = false;
    },

    descargarFacturas(tipo) {
      if (!this.fecha_anexo) {
        this.snackbar_text = "Seleccione una fecha";
        this.snackbar = true;
        return;
      }

      if (this.$store.state.emp.id_empresa) {
        this.loading_facturas = true;

        axios
          .get(
            "api/Facturas/ListarAscendente/" + this.$store.state.emp.id_empresa
          )
          .then((response) => {
            if (Array.isArray(response.data)) {
              const fechaBase = new Date(this.fecha_anexo + "T00:00:00");

              const desde = new Date(fechaBase);
              desde.setHours(0, 0, 0, 0);

              const hasta = new Date(fechaBase);
              hasta.setHours(16, 0, 0, 0);

              const ccfData = response.data
                .filter((item) => {
                  const fechaItem = new Date(item.fecha);

                  return (
                    parseFloat(item.sello_recepcion) > 0 &&
                    fechaItem >= desde &&
                    fechaItem <= hasta
                  );
                })
                .map((item) => {
                  const cliente = this.getClienteByIdLocal(item.id_cliente);

                  if (cliente) {
                    item.nit =
                      cliente.id_identificador == "1" && cliente.documento
                        ? cliente.documento.replace(/-/g, "")
                        : "";

                    item.dui =
                      cliente.id_identificador == "2" && cliente.documento
                        ? cliente.documento.replace(/-/g, "")
                        : "";

                    item.nombre = cliente.nombre || "No disponible";
                  } else {
                    item.nit = "N/A";
                    item.dui = "N/A";
                    item.nombre = "Cliente no encontrado";
                  }

                  return item;
                });

              const id_factura = ccfData.map((item) => item.id_factura);
              if (id_factura.length > 0) {
                const parametros = {
                  id_facturas: id_factura,
                  tipo_doc: tipo,
                  server: "SERVER",
                  fecha: this.fecha_anexo,
                };

                axios
                  .post("api/Facturas/ReporteCorteCaja", parametros)
                  .then((response) => {
                    const reporteURL = response.data;

                    // Descargar el archivo PDF
                    const link = document.createElement("a");
                    link.href = reporteURL;
                    link.setAttribute("download", `Corte_Caja.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    this.base64_doc =
                      "data:application/pdf;base64," + response.data;
                    this.dialog_preview_report = true;

                    this.snackbar_text = "Reporte generado exitosamente";
                    this.snackbar = true;
                  })
                  .catch(() => {
                    this.snackbar_text = "No se pudo generar el corte de caja";
                    this.snackbar = true;
                  })
                  .finally(() => {
                    this.loading_facturas = false;
                  });
              } else {
                this.snackbar_text =
                  "No hay documentos para la fecha seleccionada";
                this.snackbar = true;
                this.loading_facturas = false;
              }
            } else {
              this.snackbar_text = "Error en la respuesta del servidor";
              this.snackbar = true;
              this.loading_facturas = false;
            }
          })
          .catch(() => {
            this.snackbar_text = "No se pudo descargar el corte de caja";
            this.snackbar = true;
            this.loading_facturas = false;
          });
      } else {
        console.error("El id_empresa es undefined");
      }
    },
    alerta(icon, mensaje) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: true,
        timer: 0,
        width: 800,
      });

      Toast.fire({
        icon: icon,
        title: mensaje,
      });
    },

    filtrarFacturasPorFecha(facturas, fecha_anexo) {
      //"YYYY-MM-DD"
      const fechaBase = new Date(fecha_anexo + "T00:00:00");

      const desde = new Date(fechaBase);
      desde.setHours(0, 0, 0, 0);

      //corte hasta 16:00 
      const hasta = new Date(fechaBase);
      hasta.setHours(16, 0, 0, 0);

      return facturas.filter(f => {
        const fechaF = new Date(f.fecha);
        return fechaF >= desde && fechaF <= hasta;
      });
    },

    resumenPorTipoDoc(facturas) {
      const normalizarTipo = (f) =>
        ((f.cod_doc_fiscal || "") + "").trim().toUpperCase();

      const esAnulada = (f) => {
        if (f.es_anulado === true) return true;
        if (f.resolucion_invalidacion != null && f.resolucion_invalidacion !== "")
          return true;
        return false;
      };

      const init = () => ({
        cantidad: 0,
        exentas: 0,
        no_sujetas: 0,
        gravadas: 0,
        iva: 0,
        total_pagar: 0,
      });

      const grupos = {};
      const totales = init();

      for (const f of facturas) {
        const tipo = normalizarTipo(f) || "SIN_TIPO";
        if (!grupos[tipo]) grupos[tipo] = init();

        const anulada = esAnulada(f);

        const exentas = anulada ? 0 : Number(f.exentas || 0);
        const no_sujetas = anulada ? 0 : Number(f.no_sujetas || 0);
        const gravadas = anulada ? 0 : Number(f.gravadas || 0);
        const iva = anulada ? 0 : Number(f.iva || 0);
        const total_pagar = anulada ? 0 : Number(f.total_pagar || 0);

        grupos[tipo].cantidad += 1;
        grupos[tipo].exentas += exentas;
        grupos[tipo].no_sujetas += no_sujetas;
        grupos[tipo].gravadas += gravadas;
        grupos[tipo].iva += iva;
        grupos[tipo].total_pagar += total_pagar;

        totales.cantidad += 1;
        totales.exentas += exentas;
        totales.no_sujetas += no_sujetas;
        totales.gravadas += gravadas;
        totales.iva += iva;
        totales.total_pagar += total_pagar;
      }

      return { grupos, totales };
    },


  },
};
</script>

<style>
#myPDF {
  width: 100%;
  height: 100%;
}
</style>